var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};

// server/utils/constants.js
var require_constants = __commonJS({
  "server/utils/constants.js"(exports, module) {
    var STATE = {
      ON: 1,
      OFF: 0
    };
    var BUTTON_STATUS = {
      CLICK: 1,
      DOUBLE_CLICK: 2,
      LONG_CLICK_PRESS: 3,
      LONG_CLICK_RELEASE: 4,
      HOLD_CLICK: 5,
      LONG_CLICK: 6,
      ON: 7,
      OFF: 8,
      BRIGHTNESS_MOVE_DOWN: 9,
      BRIGHTNESS_MOVE_UP: 10,
      BRIGHTNESS_STOP: 11,
      ARROW_LEFT_CLICK: 12,
      ARROW_RIGHT_CLICK: 13,
      ARROW_LEFT_HOLD: 14,
      ARROW_RIGHT_HOLD: 15,
      ARROW_LEFT_RELEASE: 16,
      ARROW_RIGHT_RELEASE: 17,
      TRIPLE: 18,
      QUADRUPLE: 19,
      RELEASE: 20,
      MANY: 21,
      SHAKE: 22,
      THROW: 23,
      WAKEUP: 24,
      FALL: 25,
      TAP: 26,
      SLIDE: 27,
      FLIP_180: 28,
      FLIP_90: 29,
      ROTATE_LEFT: 30,
      ROTATE_RIGHT: 31,
      VIBRATION: 32,
      TILT: 33,
      DROP: 34,
      EMERGENCY: 35,
      DISARM: 36,
      ARM_DAY_ZONES: 37,
      ARM_ALL_ZONES: 38,
      ON_PRESS: 39,
      ON_HOLD: 40,
      UP_PRESS: 41,
      UP_HOLD: 42,
      DOWN_PRESS: 43,
      DOWN_HOLD: 44,
      OFF_PRESS: 45,
      OFF_HOLD: 46,
      INITIAL_PRESS: 47,
      LONG_PRESS: 48,
      SHORT_RELEASE: 49,
      LONG_RELEASE: 50,
      DOUBLE_PRESS: 51,
      TOGGLE: 52,
      TOGGLE_HOLD: 53,
      BRIGHTNESS_UP_CLICK: 54,
      BRIGHTNESS_UP_HOLD: 55,
      BRIGHTNESS_UP_RELEASE: 56,
      BRIGHTNESS_DOWN_CLICK: 57,
      BRIGHTNESS_DOWN_HOLD: 58,
      BRIGHTNESS_DOWN_RELEASE: 59,
      PRESSED: 60,
      SINGLE_LEFT: 61,
      SINGLE_RIGHT: 62,
      SINGLE_BOTH: 63,
      DOUBLE_LEFT: 64,
      DOUBLE_RIGHT: 65,
      DOUBLE_BOTH: 66,
      TRIPLE_LEFT: 67,
      TRIPLE_RIGHT: 68,
      TRIPLE_BOTH: 69,
      HOLD_LEFT: 70,
      HOLD_RIGHT: 71,
      HOLD_BOTH: 72,
      SINGLE_PLUS: 73,
      SINGLE_CENTER: 74,
      SINGLE_MINUS: 75,
      DOUBLE_PLUS: 76,
      DOUBLE_CENTER: 77,
      DOUBLE_MINUS: 78,
      HOLD_PLUS: 79,
      HOLD_CENTER: 80,
      HOLD_MINUS: 81,
      RELEASE_PLUS: 82,
      RELEASE_CENTER: 83,
      RELEASE_MINUS: 84,
      ON_DOUBLE: 85,
      OFF_DOUBLE: 86,
      ARM_NIGHT_ZONES: 87,
      EXIT_DELAY: 88,
      SINGLE_BUTTON_1: 89,
      DOUBLE_BUTTON_1: 90,
      LONG_BUTTON_1: 91,
      TRIPLE_BUTTON_1: 92,
      SINGLE_BUTTON_2: 93,
      DOUBLE_BUTTON_2: 94,
      LONG_BUTTON_2: 95,
      TRIPLE_BUTTON_2: 96,
      SINGLE_BUTTON_3: 97,
      DOUBLE_BUTTON_3: 98,
      LONG_BUTTON_3: 99,
      TRIPLE_BUTTON_3: 100,
      SINGLE_BUTTON_4: 101,
      DOUBLE_BUTTON_4: 102,
      LONG_BUTTON_4: 103,
      TRIPLE_BUTTON_4: 104
    };
    var BUTTON_PUSH = {
      PRESSED: 1
    };
    var COVER_STATE = {
      STOP: 0,
      OPEN: 1,
      CLOSE: -1
    };
    var LOCK = {
      ACTION: {
        UNLOCK: 0,
        LOCK: 1
      },
      STATE: {
        UNLOCKED: 0,
        LOCKED: 1,
        ACTIVITY: 2,
        ERROR: 3
      }
    };
    var SIREN_LMH_VOLUME = {
      LOW: 0,
      MEDIUM: 1,
      HIGH: 2
    };
    var AC_MODE = {
      AUTO: 0,
      COOLING: 1,
      HEATING: 2,
      DRYING: 3,
      FAN: 4
    };
    var CAMERA_MOVE = {
      STOP: 0,
      PAN_LEFT: 1,
      PAN_RIGHT: 2,
      TILT_UP: 3,
      TILT_DOWN: 4,
      ZOOM_IN: 5,
      ZOOM_OUT: 6
    };
    var THERMOSTAT_MODE = {
      OFF: 0,
      HEATING: 1,
      COOLING: 2,
      AUTO: 3
    };
    var THERMOSTAT_OPERATING_STATE = {
      IDLE: 0,
      HEATING: 1,
      COOLING: 2
    };
    var FAN_MODE = {
      OFF: 0,
      LOW: 1,
      MEDIUM: 2,
      HIGH: 3,
      AUTO: 4
    };
    var FAN_AIRFLOW_DIRECTION = {
      FORWARD: 0,
      REVERSE: 1
    };
    var FAN_ROCK_SETTING = {
      OFF: 0,
      LEFT_RIGHT: 1,
      UP_DOWN: 2,
      LEFT_RIGHT_AND_UP_DOWN: 3,
      ROUND: 4,
      LEFT_RIGHT_AND_ROUND: 5,
      UP_DOWN_AND_ROUND: 6,
      ALL: 7
    };
    var FAN_WIND_SETTING = {
      OFF: 0,
      SLEEP: 1,
      NATURAL: 2,
      SLEEP_AND_NATURAL: 3
    };
    var AC_FAN_SPEED = {
      AUTO: 0,
      LOW: 1,
      LOW_MID: 2,
      MID: 3,
      MID_HIGH: 4,
      HIGH: 5,
      QUIET: 6,
      TURBO: 7
    };
    var AC_SWING_HORIZONTAL = {
      OFF: 0,
      SWING: 1,
      POSITION_1: 2,
      POSITION_2: 3,
      POSITION_3: 4,
      POSITION_4: 5,
      POSITION_5: 6,
      SWING_OPPOSITE: 7
    };
    var AC_SWING_VERTICAL = {
      OFF: 0,
      SWING: 1,
      POSITION_1: 2,
      POSITION_2: 3,
      POSITION_3: 4,
      POSITION_4: 5,
      POSITION_5: 6
    };
    var PILOT_WIRE_MODE = {
      OFF: 0,
      FROST_PROTECTION: 1,
      ECO: 2,
      COMFORT_1: 3,
      COMFORT_2: 4,
      COMFORT: 5
    };
    var MUSIC_PLAYBACK_STATE = {
      PLAYING: 1,
      PAUSED: 0
    };
    var OPENING_SENSOR_STATE = {
      OPEN: 0,
      CLOSE: 1
    };
    var LIQUID_STATE = {
      LOW: 0,
      NORMAL: 1,
      HIGH: 2
    };
    var WATER_VALVE_CURRENT_DEVICE_STATUS = {
      NORMAL_STATE: 0,
      WATER_SHORTAGE: 1,
      WATER_LEAKAGE: 2,
      WATER_SHORTAGE_AND_WATER_LEAKAGE: 3
    };
    var WATER_HEATER_MODE = {
      OFF: 0,
      // appliance stopped (frost protection may remain active)
      AUTO: 1,
      // the appliance decides, learning the household's consumption
      ECO: 2,
      // energy-saving mode: heat-pump-only on a heat-pump appliance,
      // consumption learning on a plain electric tank
      BOOST: 3,
      // the fastest heating the appliance is capable of
      MANUAL: 4,
      // fixed setpoint, no learning
      AWAY: 5,
      // holiday / away, minimum temperature kept
      PROGRAM: 6
      // follows the schedule stored in the appliance
    };
    var LEVEL_MATTER_STATE = {
      LOW: 1,
      MEDIUM: 2,
      HIGH: 3,
      CRITICAL: 4
    };
    var AIR_QUALITY_LEVEL = {
      UNKNOWN: 0,
      GOOD: 1,
      FAIR: 2,
      MODERATE: 3,
      POOR: 4,
      VERY_POOR: 5,
      EXTREMELY_POOR: 6
    };
    var VACUUM_CLEANER_STATE = {
      STOPPED: 0,
      RUNNING: 1,
      PAUSED: 2,
      ERROR: 3,
      RETURNING_TO_DOCK: 4,
      CHARGING: 5,
      DOCKED: 6
    };
    var VACUUM_CLEANER_MODE = {
      IDLE: 0,
      CLEANING: 1,
      MAPPING: 2
    };
    var VACUUM_CLEANER_CLEAN_MODE = {
      AUTO: 0,
      QUICK: 1,
      QUIET: 2,
      LOW_NOISE: 3,
      DEEP_CLEAN: 4,
      VACUUM: 5,
      MOP: 6
    };
    var CHARGING_STATION_CONNECTOR_STATUS = {
      AVAILABLE: 0,
      OCCUPIED: 1,
      RESERVED: 2,
      UNAVAILABLE: 3,
      FAULTED: 4
    };
    var CHARGING_STATION_CHARGING_STATE = {
      CHARGING: 0,
      EV_CONNECTED: 1,
      PAUSED_BY_VEHICLE: 2,
      PAUSED_BY_CHARGER: 3,
      IDLE: 4,
      DISCHARGING: 5
    };
    var USER_ROLE = {
      ADMIN: "admin",
      HABITANT: "habitant",
      GUEST: "guest"
    };
    var AVAILABLE_LANGUAGES = {
      EN: "en",
      FR: "fr",
      DE: "de"
    };
    var SESSION_TOKEN_TYPES = {
      ACCESS_TOKEN: "access_token",
      REFRESH_TOKEN: "refresh_token",
      API_KEY: "api_key"
    };
    var SERVICE_STATUS = {
      UNKNOWN: "UNKNOWN",
      ENABLED: "ENABLED",
      DISABLED: "DISABLED",
      LOADING: "LOADING",
      RUNNING: "RUNNING",
      DEGRADED: "DEGRADED",
      STOPPED: "STOPPED",
      ERROR: "ERROR"
    };
    var SERVICE_TYPES = {
      INTERNAL: "internal",
      EXTERNAL: "external"
    };
    var INTEGRATION_CATALOG_CATEGORIES = [
      "climate",
      "lighting",
      "energy",
      "security",
      "multimedia",
      "appliances",
      "environment",
      "protocols",
      "network",
      "notifications",
      "assistants",
      "services"
    ];
    var SYSTEM_VARIABLE_NAMES = {
      DEVICE_STATE_HISTORY_IN_DAYS: "DEVICE_STATE_HISTORY_IN_DAYS",
      DEVICE_AGGREGATE_STATE_HISTORY_IN_DAYS: "DEVICE_AGGREGATE_STATE_HISTORY_IN_DAYS",
      DEVICE_STATE_MONTHLY_AGGREGATES_RETENTION_IN_DAYS: "DEVICE_STATE_MONTHLY_AGGREGATES_RETENTION_IN_DAYS",
      DEVICE_STATE_DAILY_AGGREGATES_RETENTION_IN_DAYS: "DEVICE_STATE_DAILY_AGGREGATES_RETENTION_IN_DAYS",
      DEVICE_STATE_HOURLY_AGGREGATES_RETENTION_IN_DAYS: "DEVICE_STATE_HOURLY_AGGREGATES_RETENTION_IN_DAYS",
      DEVICE_STATE_NUMBER_OF_HOURS_BEFORE_STATE_IS_OUTDATED: "DEVICE_STATE_NUMBER_OF_HOURS_BEFORE_STATE_IS_OUTDATED",
      GLADYS_GATEWAY_BACKUP_KEY: "GLADYS_GATEWAY_BACKUP_KEY",
      GLADYS_GATEWAY_USERS_KEYS: "GLADYS_GATEWAY_USERS_KEYS",
      GLADYS_GATEWAY_GOOGLE_HOME_USER_IS_CONNECTED_WITH_GATEWAY: "GLADYS_GATEWAY_GOOGLE_HOME_USER_IS_CONNECTED_WITH_GATEWAY",
      GLADYS_GATEWAY_ALEXA_USER_IS_CONNECTED_WITH_GATEWAY: "GLADYS_GATEWAY_ALEXA_USER_IS_CONNECTED_WITH_GATEWAY",
      TIMEZONE: "TIMEZONE",
      DEVICE_BATTERY_LEVEL_WARNING_THRESHOLD: "DEVICE_BATTERY_LEVEL_WARNING_THRESHOLD",
      DEVICE_BATTERY_LEVEL_WARNING_ENABLED: "DEVICE_BATTERY_LEVEL_WARNING_ENABLED",
      AI_WEEKLY_DIGEST_ENABLED: "AI_WEEKLY_DIGEST_ENABLED",
      AI_WEEKLY_DIGEST_DAY: "AI_WEEKLY_DIGEST_DAY",
      AI_WEEKLY_DIGEST_HOUR: "AI_WEEKLY_DIGEST_HOUR",
      DUCKDB_MIGRATED: "DUCKDB_MIGRATED",
      DUCKDB_ORPHANED_STATES_PURGED: "DUCKDB_ORPHANED_STATES_PURGED",
      GLADYS_VERSION: "GLADYS_VERSION"
    };
    var EVENTS = {
      ALARM: {
        ARM: "alarm.arm",
        ARMING: "alarm.arming",
        DISARM: "alarm.disarm",
        PARTIAL_ARM: "alarm.partial-arm",
        PANIC: "alarm.panic",
        TOO_MANY_CODES_TESTS: "alarm.too-many-codes-tests"
      },
      CALENDAR: {
        EVENT_IS_COMING: "calendar.event-is-coming",
        CHECK_IF_EVENT_IS_COMING: "calendar.check-if-event-is-coming"
      },
      DEVICE: {
        NEW: "device.new",
        CREATE: "device.create",
        UPDATE: "device.update",
        DELETE: "device.delete",
        ADD_FEATURE: "device.add-feature",
        ADD_PARAM: "device.add-param",
        NEW_STATE: "device.new-state",
        PURGE_STATES: "device.purge-states",
        CALCULATE_HOURLY_AGGREGATE: "device.calculate-hourly-aggregate",
        PURGE_STATES_SINGLE_FEATURE: "device.purge-states-single-feature",
        CHECK_BATTERIES: "device.check-batteries",
        MIGRATE_FROM_SQLITE_TO_DUCKDB: "device.migrate-from-sqlite-to-duckdb",
        PURGE_ALL_SQLITE_STATES: "device.purge-all-sqlite-states",
        PURGE_ORPHANED_DUCKDB_STATES: "device.purge-orphaned-duckdb-states"
      },
      GATEWAY: {
        CREATE_BACKUP: "gateway.create-backup",
        CHECK_IF_BACKUP_NEEDED: "gateway.check-if-backup-needed",
        RESTORE_BACKUP: "gateway.restore-backup",
        NEW_MESSAGE_API_CALL: "gateway.new-message-api-call",
        NEW_MESSAGE_OWNTRACKS_LOCATION: "gateway.new-message-owntracks-location",
        NEW_MESSAGE_EXTERNAL_INTEGRATION_WEBHOOK: "gateway.new-message-external-integration-webhook",
        LINK_STATUS_CHANGED: "gateway.link-status-changed",
        USER_KEYS_CHANGED: "gateway.user-keys-changed",
        SEND_WEEKLY_DIGEST: "gateway.send-weekly-digest"
      },
      USER_SLEEP: {
        TIME_TO_WAKE_UP: "user.time-to-wake-up",
        CANCELED_WAKE_UP: "user.canceled-wake-up",
        WOKE_UP: "user.woke-up",
        FELL_ASLEEP: "user.fell-asleep",
        CANCELED_SLEEP: "user.canceled_sleep",
        TIME_TO_SLEEP: "user.time-to-sleep"
      },
      USER_PRESENCE: {
        LEFT_HOME: "user.left-home",
        BACK_HOME: "user.back-home",
        SEEN_AT_HOME: "user.seen-at-home"
      },
      USER_WORK: {
        TIME_TO_GO_TO_WORK: "user.time-to-go-to-work",
        CANCELED_GOING_TO_WORK: "user.canceled-going-to-work",
        ARRIVED_AT_WORK: "user.arrived-at-work",
        TIME_TO_LEAVE_WORK: "user.time-to-leave-work",
        CANCELED_LEAVING_WORK: "user.canceled-leaving-work"
      },
      HOUSE_ALARM: {
        ATTEMPTED_TO_ARM: "house.attempted-to-arm",
        ARMED: "house.armed",
        FAILED_TO_ARM: "house.failed-to-arm",
        ATTEMPTED_TO_DISARM: "house.attempted-to-disarm",
        FAILED_TO_DISARM: "house.failed-to-disarm",
        TRIGGERED: "house.triggered",
        TRIGGERED_STOPPED: "house.triggered-stopped",
        DISARMED: "house.disarmed"
      },
      SUN: {
        SUNSET: "sun.sunset",
        SUNRISE: "sun.sunrise"
      },
      SCENE: {
        TRIGGERED: "scene.triggered",
        SUCCEEDED: "scene.succeeded",
        FAILED: "scene.failed"
      },
      ACTION: {
        TRIGGERED: "action.triggered"
      },
      LIGHT: {
        TURNED_ON: "light.turned-on",
        TURNED_OFF: "light.turned-off",
        BRIGHTNESS_CHANGED: "light.brightness-changed",
        HUE_CHANGED: "light.hue-changed",
        SATURATION_CHANGED: "light.saturation-changed"
      },
      TIME: {
        CHANGED: "time.changed",
        SUNRISE: "time.sunrise",
        SUNSET: "time.sunset"
      },
      TRIGGERS: {
        CHECK: "trigger.check"
      },
      TEMPERATURE_SENSOR: {
        TEMPERATURE_CHANGED: "temperature.changed"
      },
      HUMIDITY_SENSOR: {
        HUMIDITY_CHANGED: "humidity.changed"
      },
      SCHEDULED_SCENE: {
        ENABLED: "scheduled-scene.enabled",
        DISABLED: "scheduled-scene.disabled",
        TRIGGERED: "scheduled-scene.triggered"
      },
      MESSAGE: {
        NEW: "message.new",
        NEW_FOR_OPEN_AI: "message.new-for-open-ai",
        PURGE_OLD_MESSAGES: "message.purge-old-messages"
      },
      SYSTEM: {
        UPGRADE_CONTAINERS: "system.upgrade-containers",
        CHECK_UPGRADE: "system.check-upgrade",
        TIMEZONE_CHANGED: "system.timezone-changed",
        VACUUM: "system.vacuum",
        START: "system.start",
        WATCHTOWER_LOG: "system.watchtower-log"
      },
      WEBSOCKET: {
        SEND: "websocket.send",
        SEND_ALL: "websocket.send-all"
      },
      HOUSE: {
        CREATED: "house.created",
        UPDATED: "house.updated",
        DELETED: "house.deleted",
        EMPTY: "house.empty",
        NO_LONGER_EMPTY: "house.no-longer-empty"
      },
      USER: {
        NEW_LOCATION: "user.new-location"
      },
      AREA: {
        USER_ENTERED: "area.user-entered",
        USER_LEFT: "area.user-left"
      },
      JOB: {
        PURGE_OLD_JOBS: "job.purge-old-jobs"
      },
      MQTT: {
        RECEIVED: "mqtt.received"
      },
      WEATHER: {
        CHECK_ALERTS: "weather.check-alerts",
        ALERT_RAISED: "weather.alert-raised",
        ALERT_ENDED: "weather.alert-ended"
      },
      EXTERNAL_INTEGRATION: {
        STATUS_CHANGED: "external-integration.status-changed",
        DISCOVERED_DEVICES_UPDATED: "external-integration.discovered-devices-updated",
        CONNECTION_STATUS_UPDATED: "external-integration.connection-status-updated",
        DEVICE_TRANSPORT_UPDATED: "external-integration.device-transport-updated",
        CLEAN_IMAGES: "external-integration.clean-images"
      }
    };
    var LIFE_EVENTS = {
      USER_SLEEP: EVENTS.USER_SLEEP,
      USER_PRESENCE: EVENTS.USER_PRESENCE,
      USER_WORK: EVENTS.WORK
    };
    var STATES = {
      USER_SLEEP: {
        ASLEEP: "user.asleep",
        NEED_TO_WAKE_UP: "user.need-to-wake-up",
        AWAKE: "user.awake",
        NEED_TO_SLEEP: "user.need-to-sleep"
      },
      USER_PRESENCE: {
        AT_HOME: "user.at-home",
        OUT: "user.out"
      },
      USER_WORK: {
        NOT_AT_WORK: "user.not-at-work",
        NEED_TO_GO_TO_WORK: "user.need-to-go-to-work",
        AT_WORK: "user.at-work",
        NEED_TO_LEAVE_WORK: "user.need-to-leave-work"
      },
      HOUSE_ALARM: {
        DISARMED: "house.alarm.disarmed",
        TRYING_TO_ARM: "house.alarm.trying-to-arm",
        ARMED: "house.alarm.armed",
        TRYING_TO_DISARM: "house.alarm.trying-to-disarm",
        TRIGGERED: "house.alarm.triggered"
      }
    };
    var CONDITIONS = {
      USER_SLEEP: {
        IS_ASLEEP: "user.is-asleep",
        IS_AWAKE: "user.is-awake",
        NEED_TO_WAKE_UP: "user.need-to-wake-up",
        NEEED_TO_SLEEP: "user.need-to-sleep"
      },
      USER_PRESENCE: {
        IS_AT_HOME: "user.is-at-home",
        IS_OUT: "user.is-out"
      },
      USER_WORK: {
        IS_NOT_AT_WORK: "user.is-not-at-work",
        NEED_TO_GO_TO_WORK: "user.need-to-go-to-work",
        IS_AT_WORK: "user.is-at-work",
        NEED_TO_LEAVE_WORK: "user.need-to-leave-work"
      },
      HOUSE_ALARM: {
        IS_DISARMED: "house.alarm.is-disarmed",
        IS_TRYING_TO_ARM: "house.alarm.is-trying-to-arm",
        IS_ARMED: "house.alarm.is-armed",
        IS_TRYING_TO_DISARM: "house.alarm.is-trying-to-disarm",
        IS_TRIGGERED: "house.alarm.is-triggered"
      }
    };
    var ACTIONS = {
      AI: {
        ASK: "ai.ask"
      },
      ALARM: {
        CHECK_ALARM_MODE: "alarm.check-alarm-mode",
        SET_ALARM_MODE: "alarm.set-alarm-mode"
      },
      CALENDAR: {
        IS_EVENT_RUNNING: "calendar.is-event-running",
        GET_EVENTS: "calendar.get-events"
      },
      DEVICE: {
        SET_VALUE: "device.set-value",
        GET_VALUE: "device.get-value"
      },
      LIGHT: {
        TURN_ON: "light.turn-on",
        TURN_OFF: "light.turn-off",
        TOGGLE: "light.toggle",
        BLINK: "light.blink"
      },
      SWITCH: {
        TURN_ON: "switch.turn-on",
        TURN_OFF: "switch.turn-off",
        TOGGLE: "switch.toggle"
      },
      TIME: {
        DELAY: "delay"
      },
      SCENE: {
        START: "scene.start"
      },
      MESSAGE: {
        SEND: "message.send",
        SEND_CAMERA: "message.send-camera"
      },
      CONDITION: {
        ONLY_CONTINUE_IF: "condition.only-continue-if",
        CHECK_TIME: "condition.check-time",
        IF_THEN_ELSE: "condition.if-then-else",
        WHILE: "condition.while"
      },
      USER: {
        SET_SEEN_AT_HOME: "user.set-seen-at-home",
        SET_OUT_OF_HOME: "user.set-out-of-home",
        CHECK_PRESENCE: "user.check-presence"
      },
      HOUSE: {
        IS_EMPTY: "house.is-empty",
        IS_NOT_EMPTY: "house.is-not-empty"
      },
      HTTP: {
        REQUEST: "http.request"
      },
      ECOWATT: {
        CONDITION: "ecowatt.condition"
      },
      EDF_TEMPO: {
        CONDITION: "edf-tempo.condition"
      },
      MQTT: {
        SEND: "mqtt.send"
      },
      ZIGBEE2MQTT: {
        SEND: "zigbee2mqtt.send"
      },
      MUSIC: {
        PLAY_NOTIFICATION: "music.play-notification"
      },
      SMS: {
        SEND: "sms.send"
      },
      VARIABLE: {
        SET: "variable.set"
      }
    };
    var CONDITION_ACTIONS = [
      ACTIONS.CONDITION.CHECK_TIME,
      ACTIONS.CONDITION.ONLY_CONTINUE_IF,
      ACTIONS.EDF_TEMPO.CONDITION,
      ACTIONS.ALARM.CHECK_ALARM_MODE,
      ACTIONS.CALENDAR.IS_EVENT_RUNNING,
      ACTIONS.CALENDAR.GET_EVENTS,
      ACTIONS.ECOWATT.CONDITION,
      ACTIONS.HOUSE.IS_EMPTY,
      ACTIONS.HOUSE.IS_NOT_EMPTY
    ];
    var INTENTS = {
      LIGHT: {
        TURN_ON: "intent.light.turn-on",
        TURN_OFF: "intent.light.turn-off"
      },
      TEMPERATURE_SENSOR: {
        GET_IN_ROOM: "intent.temperature-sensor.get-in-room"
      },
      HUMIDITY_SENSOR: {
        GET_IN_ROOM: "intent.humidity-sensor.get-in-room"
      },
      WEATHER: {
        GET: "intent.weather.get",
        TOMORROW: "intent.weather.tomorrow",
        AFTER_TOMORROW: "intent.weather.after-tomorrow",
        DAY: "intent.weather.day"
      },
      CAMERA: {
        GET_IMAGE: "intent.camera.get-image"
      },
      SCENE: {
        START: "intent.scene.start"
      },
      SWITCH: {
        TURN_ON: "intent.switch.turn-on",
        TURN_OFF: "intent.switch.turn-off"
      }
    };
    var DEVICE_FEATURE_CATEGORIES = {
      CHILD_LOCK: "child-lock",
      AIRQUALITY_SENSOR: "airquality-sensor",
      AIR_CONDITIONING: "air-conditioning",
      ANGLE_SENSOR: "angle-sensor",
      BATTERY: "battery",
      BATTERY_LOW: "battery-low",
      BATTERY_STORAGE: "battery-storage",
      BUTTON: "button",
      CAMERA: "camera",
      CHARGING_STATION: "charging-station",
      CUBE: "cube",
      CURRENCY: "currency",
      CO_SENSOR: "co-sensor",
      CO2_SENSOR: "co2-sensor",
      COUNTER_SENSOR: "counter-sensor",
      CURTAIN: "curtain",
      DATA: "data",
      DATARATE: "datarate",
      DEVICE_TEMPERATURE_SENSOR: "device-temperature-sensor",
      DISTANCE_SENSOR: "distance-sensor",
      DOORBELL: "doorbell",
      DURATION: "duration",
      ELECTRICAL_VEHICLE_BATTERY: "electrical-vehicle-battery",
      ELECTRICAL_VEHICLE_CHARGE: "electrical-vehicle-charge",
      ELECTRICAL_VEHICLE_DRIVE: "electrical-vehicle-drive",
      ELECTRICAL_VEHICLE_CONSUMPTION: "electrical-vehicle-consumption",
      ELECTRICAL_VEHICLE_STATE: "electrical-vehicle-state",
      ELECTRICAL_VEHICLE_CLIMATE: "electrical-vehicle-climate",
      ELECTRICAL_VEHICLE_COMMAND: "electrical-vehicle-command",
      ENERGY_SENSOR: "energy-sensor",
      ENERGY_PRODUCTION_SENSOR: "energy-production-sensor",
      FAN: "fan",
      GRID_SENSOR: "grid-sensor",
      HEATER: "heater",
      HEPA_FILTER_MONITORING: "hepa-filter-monitoring",
      HOME_OUTPUT_SENSOR: "home-output-sensor",
      HUMIDITY_SENSOR: "humidity-sensor",
      LEAK_SENSOR: "leak-sensor",
      LIGHT: "light",
      LIGHT_SENSOR: "light-sensor",
      LEVEL_SENSOR: "level-sensor",
      MOTION_SENSOR: "motion-sensor",
      LOCK: "lock",
      // Generic consumable/wear-part monitoring (vacuum brushes, dust bags, mop pads, softener resin,
      // detergent...). One feature per component, the feature `name` identifies the component: don't
      // add a new per-component type/category here when the value is just "remaining life in percent".
      // Boundary with neighboring categories: filter life reported through the Matter Resource
      // Monitoring model (HEPA and activated carbon filters) stays in HEPA_FILTER_MONITORING, every
      // other consumable or wear part goes here, so the same quantity is never split across categories.
      // The name `maintenance` is deliberate: it is a user-facing category name in the UI, kept broader
      // and simpler than a Matter-style `consumable-monitoring`. Renaming it later would be breaking.
      MAINTENANCE: "maintenance",
      MUSIC: "music",
      NOISE_SENSOR: "noise-sensor",
      OPENING_SENSOR: "opening-sensor",
      ORP_SENSOR: "orp-sensor",
      PH_SENSOR: "ph-sensor",
      PM25_SENSOR: "pm25-sensor",
      PM10_SENSOR: "pm10-sensor",
      FORMALDEHYD_SENSOR: "formaldehyd-sensor",
      // Gaseous air pollutants, one category per gas, holding the raw mass concentration measured in
      // the air (µg/m³ by default, non-negative). Boundary with the neighbouring air quality
      // categories: an index synthesizing several pollutants goes to `airquality-sensor`, and a
      // protocol-specific severity level (Matter reports these gases as a 0-4 LevelValue, see
      // `no2-matter-index-sensor`) is not a concentration and must not be published here. Whichever
      // form the device natively reports is the one the integration maps, never both for the same
      // measurement.
      NO2_SENSOR: "no2-sensor",
      O3_SENSOR: "o3-sensor",
      SO2_SENSOR: "so2-sensor",
      PRECIPITATION_SENSOR: "precipitation-sensor",
      PRESENCE_SENSOR: "presence-sensor",
      PRESSURE_SENSOR: "pressure-sensor",
      RAIN_SENSOR: "rain-sensor",
      RISK: "risk",
      SHUTTER: "shutter",
      SIGNAL: "signal",
      SIREN: "siren",
      SISMIC_SENSOR: "sismic-sensor",
      SMOKE_SENSOR: "smoke-sensor",
      SOIL_MOISTURE_SENSOR: "soil-moisture-sensor",
      SURFACE: "surface",
      SWITCH: "switch",
      SPEED_SENSOR: "speed-sensor",
      TAMPER: "tamper",
      TELEINFORMATION: "teleinformation",
      TELEVISION: "television",
      TEMPERATURE_SENSOR: "temperature-sensor",
      THERMOSTAT: "thermostat",
      UNKNOWN: "unknown",
      UV_SENSOR: "uv-sensor",
      VIBRATION_SENSOR: "vibration-sensor",
      VOC_SENSOR: "voc-sensor",
      VOC_INDEX_SENSOR: "voc-index-sensor",
      VOC_MATTER_INDEX_SENSOR: "voc-matter-index-sensor",
      NO2_MATTER_INDEX_SENSOR: "no2-matter-index-sensor",
      VOLUME_SENSOR: "volume-sensor",
      VACUUM_CLEANER: "vacuum-cleaner",
      TEXT: "text",
      INPUT: "input",
      WATER_HEATER: "water-heater",
      WATER_VALVE: "water-valve"
    };
    var DEVICE_FEATURE_TYPES = {
      LIGHT: {
        BINARY: "binary",
        BRIGHTNESS: "brightness",
        HUE: "hue",
        SATURATION: "saturation",
        COLOR: "color",
        TEMPERATURE: "temperature",
        POWER: "power",
        EFFECT_MODE: "effect-mode",
        EFFECT_SPEED: "effect-speed"
      },
      SENSOR: {
        DECIMAL: "decimal",
        INTEGER: "integer",
        BINARY: "binary",
        PUSH: "push",
        UNKNOWN: "unknown"
      },
      TEMPERATURE_SENSOR: {
        MIN: "min",
        MAX: "max",
        AVERAGE: "average"
      },
      SWITCH: {
        BINARY: "binary",
        POWER: "power",
        ENERGY: "energy",
        VOLTAGE: "voltage",
        CURRENT: "current",
        BURGLAR: "burglar",
        DIMMER: "dimmer",
        TARGET_CURRENT: "target-current"
      },
      LOCK: {
        BINARY: "binary",
        INTEGER: "integer",
        STATE: "state"
      },
      CAMERA: {
        IMAGE: "image",
        // PTZ control (spec docs/specs/camera-ptz-control.md). MOVE: one command feature for all
        // movements, values from CAMERA_MOVE, per-camera subset declared via supported_options.
        // PRESET: recall a saved position; the labeled list lives in supported_options, the value
        // sent is the option's integer (the integration maps it to its protocol token).
        // *_POSITION: optional absolute position, numeric read/write, bounds declared by the
        // integration via min/max (units are integration-defined: normalized ONVIF space, degrees...).
        MOVE: "move",
        PRESET: "preset",
        PAN_POSITION: "pan-position",
        TILT_POSITION: "tilt-position",
        ZOOM_POSITION: "zoom-position"
      },
      CHARGING_STATION: {
        CONNECTOR_STATUS: "connector-status",
        CHARGING_STATE: "charging-state"
      },
      DOORBELL: {
        RING: "ring"
      },
      SIREN: {
        BINARY: "binary",
        LMH_VOLUME: "lmh_volume",
        MELODY: "melody",
        TEST_IN_PROGRESS: "test-in-progress"
        // Alarm testing status (binary - sensor)
      },
      CHILD_LOCK: {
        BINARY: "binary"
      },
      CUBE: {
        MODE: "mode",
        ROTATION: "rotation"
      },
      BATTERY: {
        INTEGER: "integer"
      },
      BATTERY_LOW: {
        BINARY: "binary"
      },
      VIBRATION_SENSOR: {
        BINARY: "binary",
        STATUS: "status",
        TILT_ANGLE: "tilt-angle",
        ACCELERATION_X: "acceleration-x",
        ACCELERATION_Y: "acceleration-y",
        ACCELERATION_Z: "acceleration-z",
        ANGLE_X: "angle-x",
        ANGLE_Y: "angle-y",
        ANGLE_Z: "angle-z",
        BED_ACTIVITY: "bed-activity"
      },
      BUTTON: {
        CLICK: "click",
        PUSH: "push"
      },
      SIGNAL: {
        QUALITY: "integer"
      },
      AIR_CONDITIONING: {
        BINARY: "binary",
        MODE: "mode",
        TARGET_TEMPERATURE: "target-temperature",
        FAN_SPEED: "fan-speed",
        SWING_HORIZONTAL: "swing-horizontal",
        SWING_VERTICAL: "swing-vertical"
      },
      FAN: {
        MODE: "mode",
        PERCENT: "percent",
        SPEED: "speed",
        AIRFLOW_DIRECTION: "airflow-direction",
        ROCK_SETTING: "rock-setting",
        WIND_SETTING: "wind-setting"
      },
      HEATER: {
        PILOT_WIRE_MODE: "pilot-wire-mode"
      },
      SURFACE: {
        DECIMAL: "decimal"
      },
      TAMPER: {
        BINARY: "binary"
      },
      TELEVISION: {
        BINARY: "binary",
        SOURCE: "source",
        GUIDE: "guide",
        MENU: "menu",
        TOOLS: "tools",
        INFO: "info",
        ENTER: "enter",
        RETURN: "return",
        EXIT: "exit",
        LEFT: "left",
        RIGHT: "right",
        UP: "up",
        DOWN: "down",
        CHANNEL_UP: "channel-up",
        CHANNEL_DOWN: "channel-down",
        CHANNEL_PREVIOUS: "channel-previous",
        CHANNEL: "channel",
        VOLUME_UP: "volume-up",
        VOLUME_DOWN: "volume-down",
        VOLUME_MUTE: "volume-mute",
        VOLUME: "volume",
        PLAY: "play",
        PAUSE: "pause",
        STOP: "stop",
        PREVIOUS: "previous",
        NEXT: "next",
        REWIND: "rewind",
        FORWARD: "forward",
        RECORD: "record"
      },
      MUSIC: {
        VOLUME: "volume",
        PLAY: "play",
        PAUSE: "pause",
        PREVIOUS: "previous",
        NEXT: "next",
        PLAYBACK_STATE: "playback_state",
        PLAY_NOTIFICATION: "play_notification"
      },
      ENERGY_SENSOR: {
        BINARY: "binary",
        POWER: "power",
        ENERGY: "energy",
        VOLTAGE: "voltage",
        CURRENT: "current",
        INDEX: "index",
        INDEX_TODAY: "index-today",
        INDEX_YESTERDAY: "index-yesterday",
        DAILY_CONSUMPTION: "daily-consumption",
        DAILY_CONSUMPTION_COST: "daily-consumption-cost",
        THIRTY_MINUTES_CONSUMPTION: "thirty-minutes-consumption",
        THIRTY_MINUTES_CONSUMPTION_COST: "thirty-minutes-consumption-cost"
      },
      ENERGY_PRODUCTION_SENSOR: {
        POWER: "power",
        // instantaneous production power, in W (>= 0)
        INDEX: "index",
        DAILY_PRODUCTION: "daily-production",
        DAILY_PRODUCTION_REVENUE: "daily-production-revenue",
        THIRTY_MINUTES_PRODUCTION: "thirty-minutes-production",
        THIRTY_MINUTES_PRODUCTION_REVENUE: "thirty-minutes-production-revenue"
      },
      // Exchange with the public grid (the connection point), whatever the
      // measuring device: a plug-in battery's grid port, an EM clamp or a
      // whole-home meter all publish here, so the same physical quantity never
      // splits across categories. (teleinformation stays as-is for Linky legacy.)
      // Import/export are split so core automations can tell direction apart;
      // `power` is the signed single value some devices report instead
      // (import > 0, export < 0). An integration maps whichever form its device
      // NATIVELY reports - never both for the same measurement.
      GRID_SENSOR: {
        INPUT_POWER: "input-power",
        // instantaneous power imported from the grid, W (>= 0)
        OUTPUT_POWER: "output-power",
        // instantaneous power exported to the grid, W (>= 0)
        POWER: "power",
        // signed grid exchange when the device reports a single value (import > 0, export < 0), W
        INPUT_INDEX: "input-index",
        // cumulative imported-energy meter index, kWh (>= 0)
        OUTPUT_INDEX: "output-index"
        // cumulative exported-energy meter index, kWh (>= 0)
      },
      // The power the device ITSELF delivers to the installation it feeds (e.g. a
      // storage inverter's home output), plus its backup/off-grid output.
      // House consumption measured by an inverter (the "load power" many hybrid
      // inverters report, which can exceed the inverter's own output when the
      // grid tops up) is NOT this category - it goes to energy-sensor.
      HOME_OUTPUT_SENSOR: {
        POWER: "power",
        // instantaneous power delivered to the home, W (>= 0)
        INDEX: "index",
        // cumulative delivered-energy meter index, kWh (>= 0)
        OFF_GRID_POWER: "off-grid-power",
        // instantaneous power on the backup/off-grid output, W (>= 0)
        OFF_GRID_INDEX: "off-grid-index"
        // cumulative backup-output energy meter index, kWh (>= 0)
      },
      BATTERY_STORAGE: {
        BATTERY_LEVEL: "battery-level",
        // state of charge, % (0..100)
        CHARGE_POWER: "charge-power",
        // power INTO the battery, W/kW (>=0)
        DISCHARGE_POWER: "discharge-power",
        // power OUT of the battery, W/kW (>=0)
        CHARGE_INDEX: "charge-index",
        // cumulative charged-energy meter index, kWh
        DISCHARGE_INDEX: "discharge-index",
        // cumulative discharged-energy meter index, kWh
        BATTERY_ENERGY_REMAINING: "battery-energy-remaining"
        // currently available stored energy (instantaneous), kWh
      },
      TELEINFORMATION: {
        BINARY: "binary",
        EAST: "east",
        EAIT: "eait",
        EASF01: "easf01",
        EASF02: "easf02",
        EASF03: "easf03",
        EASF04: "easf04",
        EASF05: "easf05",
        EASF06: "easf06",
        EASF07: "easf07",
        EASF08: "easf08",
        EASF09: "easf09",
        EASF10: "easf10",
        PREF: "pref",
        PCOUP: "pcoup",
        VTIC: "vtic",
        CCASN: "ccasn",
        CCASN_1: "ccasn_1",
        UMOY1: "umoy1",
        UMOY2: "umoy2",
        UMOY3: "umoy3",
        ERQ1: "erq1",
        ERQ2: "erq2",
        ERQ3: "erq3",
        ERQ4: "erq4",
        IRMS1: "irms1",
        IRMS2: "irms2",
        IRMS3: "irms3",
        URMS1: "urms1",
        URMS2: "urms2",
        URMS3: "urms3",
        EASD01: "easd01",
        EASD02: "easd02",
        EASD03: "easd03",
        EASD04: "easd04",
        NTARF: "ntarf",
        CCAIN: "ccain",
        CCAIN_1: "ccain_1",
        SINSTI: "sinsti",
        SMAXIN: "smaxin",
        SMAXIN_1: "smaxin_1",
        SMAXN: "smaxn",
        SMAXN2: "smaxn2",
        SMAXN3: "smaxn3",
        SINSTS: "sinsts",
        SINSTS2: "sinsts2",
        SINSTS3: "sinsts3",
        SMAXN_1: "smaxn_1",
        SMAXN2_1: "smaxn2_1",
        SMAXN3_1: "smaxn3_1",
        HHPHC: "hhphc",
        IMAX: "imax",
        ADPS: "adps",
        IMAX2: "imax2",
        IMAX3: "imax3",
        ADIR1: "adir1",
        ADIR2: "adir2",
        ADIR3: "adir3"
      },
      SPEED_SENSOR: {
        DECIMAL: "decimal",
        INTEGER: "integer"
      },
      UV_SENSOR: {
        INTEGER: "integer"
      },
      CURRENCY: {
        DECIMAL: "decimal"
      },
      PRECIPITATION_SENSOR: {
        DECIMAL: "decimal",
        INTEGER: "integer"
      },
      VOLUME_SENSOR: {
        DECIMAL: "decimal",
        INTEGER: "integer"
      },
      DURATION: {
        DECIMAL: "decimal",
        INTEGER: "integer"
      },
      VOC_SENSOR: {
        DECIMAL: "decimal"
      },
      VOC_INDEX_SENSOR: {
        INTEGER: "integer"
      },
      SHUTTER: {
        STATE: "state",
        POSITION: "position"
      },
      CURTAIN: {
        STATE: "state",
        POSITION: "position"
      },
      DATA: {
        SIZE: "size"
      },
      DATARATE: {
        RATE: "rate"
      },
      UNKNOWN: {
        UNKNOWN: "unknown"
      },
      THERMOSTAT: {
        TARGET_TEMPERATURE: "target-temperature",
        MODE: "mode",
        OPERATING_STATE: "operating-state"
      },
      AIRQUALITY_SENSOR: {
        // Numeric air quality index, on the open-ended scale the AQI unit defines (0-500).
        AQI: "aqi",
        // Overall qualitative verdict the device computes itself, one of the AIR_QUALITY_LEVEL values.
        // Boundary with `aqi`: an integration maps whichever form its device natively reports, never
        // both for the same measurement, and the raw concentrations behind the verdict keep going to
        // their own per-pollutant categories (`pm25-sensor`, `co2-sensor`, `voc-sensor`...).
        LEVEL: "level"
      },
      PH_SENSOR: {
        DECIMAL: "decimal"
      },
      ORP_SENSOR: {
        DECIMAL: "decimal"
      },
      TEXT: {
        TEXT: "text",
        // A choice among string values the integration discovers on the appliance itself
        // (installed TV apps, HDMI sources, vacuum rooms, native scenes...): the choices are
        // declared per-device through supported_options ({ value, label }) and are NOT part of
        // the taxonomy. The state is the selected option's value, stored as a string
        // (last_value_string, no history). Enum-like capabilities standards cover (AC modes,
        // fan speeds...) keep their own category/type with integer values: this type is only
        // for lists no generic value set can describe.
        SELECT: "select"
      },
      RISK: {
        INTEGER: "integer"
      },
      INPUT: {
        BINARY: "binary"
      },
      LEVEL_SENSOR: {
        // Types used by the Tuya ME201WZ in Zigbee2mqtt
        LIQUID_STATE: "liquid-state",
        LIQUID_LEVEL_PERCENT: "liquid-level-percent",
        LIQUID_DEPTH: "liquid-depth"
      },
      // Domestic hot water appliances: electric storage tanks, heat-pump water heaters,
      // gas-fired water heaters. Scope is limited to producing and storing hot water.
      // Boundary with neighboring categories: the water temperature measured in the tank
      // is a temperature-sensor/decimal feature, electrical consumption is energy-sensor,
      // and room heating stays in heater/thermostat — a water heater device carries those
      // features alongside its water-heater ones.
      // Value conventions: all commands are non-negative integers; `mode` is an index into
      // WATER_HEATER_MODE, `binary`/`heating`/`boost` are 0/1. Boosting exists both as a
      // mode value and as the `boost` command: an integration maps whichever form its
      // appliance natively reports, never both for the same function.
      WATER_HEATER: {
        BINARY: "binary",
        // appliance on/off (command)
        MODE: "mode",
        // operating mode, WATER_HEATER_MODE (command)
        TARGET_TEMPERATURE: "target-temperature",
        // hot water setpoint (command)
        REMAINING_HOT_WATER: "remaining-hot-water",
        // hot water available, % or litres V40 (sensor)
        HEATING: "heating",
        // actively heating water or not (sensor)
        BOOST: "boost"
        // forced heating on/off (command)
      },
      WATER_VALVE: {
        // Types used by the SONOFF SWV in Zigbee2mqtt
        CURRENT_DEVICE_STATUS: "current-device-status",
        FLOW: "flow",
        AUTO_CLOSE_WHEN_WATER_SHORTAGE: "auto-close-when-water-shortage",
        VALVE_WORK_STATE: "valve-work-state",
        REAL_TIME_IRRIGATION_DURATION: "real-time-irrigation-duration",
        REAL_TIME_IRRIGATION_VOLUME: "real-time-irrigation-volume",
        DAILY_IRRIGATION_VOLUME: "daily-irrigation-volume"
      },
      ELECTRICAL_VEHICLE_BATTERY: {
        // Features related to the battery state and metrics of the vehicle
        BATTERY_ENERGY_REMAINING: "battery-energy-remaining",
        // Remaining energy in the battery in kWh (integer - sensor)
        BATTERY_LEVEL: "battery-level",
        // Battery state of charge in percent (integer - sensor)
        BATTERY_POWER: "battery-power",
        // Instantaneous battery power in W (integer - sensor)
        BATTERY_RANGE_ESTIMATE: "battery-range-estimate",
        // Estimated remaining range in km or miles (integer - sensor)
        BATTERY_TEMPERATURE: "battery-temperature",
        // Battery temperature in °C (integer - sensor)
        BATTERY_VOLTAGE: "battery-voltage"
        // Battery voltage in V (integer - sensor)
      },
      ELECTRICAL_VEHICLE_CHARGE: {
        // Features related to the charging process and charge control
        CHARGE_CURRENT: "charge-current",
        // Current delivered during charging in A (integer - sensor)
        CHARGE_ENERGY_ADDED_TOTAL: "charge-energy-added-total",
        // Total energy added during all charge sessions in kWh (integer - sensor)
        CHARGE_ENERGY_CONSUMPTION_TOTAL: "charge-energy-consumption-total",
        // Total energy consumed during all charge sessions in kWh (integer - sensor)
        CHARGE_ON: "charge-on",
        // Charging state (binary - command with return status)
        CHARGE_POWER: "charge-power",
        // Instantaneous charging power in W (integer - sensor)
        CHARGE_VOLTAGE: "charge-voltage",
        // Charging voltage in V (integer - sensor)
        LAST_CHARGE_ENERGY_ADDED: "last-charge-energy-added",
        // Energy added in the last charge session in kWh (integer - sensor)
        LAST_CHARGE_ENERGY_CONSUMPTION: "last-charge-energy-consumption",
        // Energy consumed in the last charge session in kWh (integer - sensor)
        PLUGGED: "plugged",
        // Whether the vehicle is plugged in (binary - sensor)
        TARGET_CHARGE_LIMIT: "target-charge-limit",
        // Target state of charge limit in percent (integer - command)
        TARGET_CURRENT: "target-current"
        // Target charging current in A (integer - command)
      },
      ELECTRICAL_VEHICLE_CLIMATE: {
        // Features related to the vehicle's climate control
        CLIMATE_ON: "climate-on",
        // Climate system activation (binary - command with return status)
        INDOOR_TEMPERATURE: "indoor-temperature",
        // Cabin temperature in °C (integer - sensor)
        TARGET_TEMPERATURE: "target-temperature"
        // Desired cabin temperature in °C (integer - command)
      },
      ELECTRICAL_VEHICLE_COMMAND: {
        // General remote commands for the vehicle
        ALARM: "alarm",
        // Enable/Disable alarm (binary - command with return status)
        LOCK: "lock"
        // Lock/unlock the vehicle (binary - command with return status)
      },
      ELECTRICAL_VEHICLE_DRIVE: {
        // Features related to driving and trip statistics
        DRIVE_ENERGY_CONSUMPTION_TOTAL: "drive-energy-consumption-total",
        // Total energy consumed while all trips in kWh (integer - sensor)
        SPEED: "speed"
        // Current speed of the vehicle in km/h or mi/h (integer - sensor)
      },
      ELECTRICAL_VEHICLE_CONSUMPTION: {
        // Features related to energy consumption and efficiency
        ENERGY_CONSUMPTION: "energy-consumption",
        // Instantaneous or average energy consumption in Wh/km, Wh/mi, kWh/100km, kWh/100mi (integer - sensor)
        ENERGY_EFFICIENCY: "energy-efficiency"
        // Energy efficiency metric in km/kWh or mi/kWh (integer - sensor)
      },
      ELECTRICAL_VEHICLE_STATE: {
        // Features related to the physical state of the vehicle
        DOOR_OPENED: "door-opened",
        // Door open state (binary - sensor)
        ODOMETER: "odometer",
        // Total distance traveled in km or miles (integer - sensor)
        TIRE_PRESSURE: "tire-pressure",
        // Tire pressure in bar (decimal - sensor)
        WINDOW_OPENED: "window-opened"
        // Window open state (binary - sensor)
      },
      FILTER_MONITORING: {
        FILTER_LIFE_REMAINING: "filter-life-remaining"
        // Remaining life of the HEPA filter in percent (integer - sensor)
      },
      MAINTENANCE: {
        LIFE_REMAINING: "life-remaining"
        // Remaining life of a consumable/wear part in percent (integer - sensor)
      },
      VACUUM_CLEANER: {
        STATE: "state",
        // Operational state of the vacuum (integer - sensor)
        RUN_MODE: "run-mode",
        // Run mode of the vacuum (integer - command)
        CLEAN_MODE: "clean-mode",
        // Clean mode of the vacuum (integer - command)
        DOCK: "dock"
        // Send vacuum to dock (binary - command)
      }
    };
    var FAN_SETTING_ENUM_BY_FEATURE_TYPE = {
      [DEVICE_FEATURE_TYPES.FAN.ROCK_SETTING]: FAN_ROCK_SETTING,
      [DEVICE_FEATURE_TYPES.FAN.WIND_SETTING]: FAN_WIND_SETTING,
      [DEVICE_FEATURE_TYPES.FAN.AIRFLOW_DIRECTION]: FAN_AIRFLOW_DIRECTION
    };
    function getFanFeatureOptions(featureType, min, max) {
      const minValue = typeof min === "number" ? min : 0;
      const maxValue = typeof max === "number" ? max : minValue;
      const fanEnum = FAN_SETTING_ENUM_BY_FEATURE_TYPE[featureType];
      if (fanEnum) {
        return Object.values(fanEnum).filter((value) => value >= minValue && value <= maxValue);
      }
      const options = [];
      for (let value = minValue; value <= maxValue; value += 1) {
        options.push(value);
      }
      return options;
    }
    var DEVICE_FEATURE_UNITS = {
      // Temperature units
      CELSIUS: "celsius",
      FAHRENHEIT: "fahrenheit",
      KELVIN: "kelvin",
      // Percentage units
      PERCENT: "percent",
      // Pressure units
      PASCAL: "pascal",
      HECTO_PASCAL: "hPa",
      KILO_PASCAL: "kPa",
      BAR: "bar",
      PSI: "psi",
      MILLIBAR: "milli-bar",
      // Light units
      LUX: "lux",
      // Concentration units
      PPM: "ppm",
      PPB: "ppb",
      PPT: "ppt",
      // Power units
      WATT: "watt",
      KILOWATT: "kilowatt",
      WATT_HOUR: "watt-hour",
      KILOWATT_HOUR: "kilowatt-hour",
      MEGAWATT_HOUR: "megawatt-hour",
      AMPERE: "ampere",
      MILLI_AMPERE: "milliampere",
      MILLI_VOLT: "millivolt",
      VOLT: "volt",
      KILOVOLT_AMPERE: "kilovolt-ampere",
      VOLT_AMPERE: "volt-ampere",
      VOLT_AMPERE_REACTIVE: "volt-ampere-reactive",
      WATT_HOUR_PER_KM: "watt-hour-per-km",
      KILOWATT_HOUR_PER_100_KM: "kilowatt-hour-per-100-km",
      WATT_HOUR_PER_MILE: "watt-hour-per-mile",
      KILOWATT_HOUR_PER_100_MILE: "kilowatt-hour-per-100-mile",
      // Efficiency units
      KM_PER_KILOWATT_HOUR: "km-per-kilowatt-hour",
      MILE_PER_KILOWATT_HOUR: "mile-per-kilowatt-hour",
      // Length units
      MM: "mm",
      CM: "cm",
      M: "m",
      KM: "km",
      INCH: "inch",
      FEET: "feet",
      MILE: "mile",
      // surface units
      SQUARE_CENTIMETER: "square-centimeter",
      SQUARE_METER: "square-meter",
      SQUARE_KILOMETER: "square-kilometer",
      // Degree units
      DEGREE: "degree",
      // Volume units
      LITER: "liter",
      MILLILITER: "milliliter",
      CUBIC_METER: "cubicmeter",
      // Flow units
      CUBIC_METER_PER_HOUR: "cubic-meter-per-hour",
      // Currency units
      EURO: "euro",
      DOLLAR: "dollar",
      BITCOIN: "bitcoin",
      LITECOIN: "litecoin",
      DOGECOIN: "dogecoin",
      ETHEREUM: "ethereum",
      POUND_STERLING: "pound-sterling",
      // Speed units
      METER_PER_SECOND: "meter-per-second",
      KILOMETER_PER_HOUR: "kilometer-per-hour",
      FEET_PER_SECOND: "feet-per-second",
      MILE_PER_HOUR: "mile-per-hour",
      // Precipitation units
      MILLIMETER_PER_HOUR: "millimeter-per-hour",
      MILLIMETER_PER_DAY: "millimeter-per-day",
      // UV units
      UV_INDEX: "uv-index",
      // Duration units
      MICROSECONDS: "microseconds",
      MILLISECONDS: "milliseconds",
      SECONDS: "seconds",
      MINUTES: "minutes",
      HOURS: "hours",
      DAYS: "days",
      WEEKS: "weeks",
      MONTHS: "months",
      YEARS: "years",
      // Data units
      BIT: "bit",
      KILOBIT: "kilobit",
      MEGABIT: "megabit",
      GIGABIT: "gigabit",
      BYTE: "byte",
      KILOBYTE: "kilobyte",
      MEGABYTE: "megabyte",
      GIGABYTE: "gigabyte",
      TERABYTE: "terabyte",
      // Data rate units
      BITS_PER_SECOND: "bits-per-second",
      KILOBITS_PER_SECOND: "kilobits-per-second",
      MEGABITS_PER_SECOND: "megabits-per-second",
      GIGABITS_PER_SECOND: "gigabits-per-second",
      BYTES_PER_SECOND: "bytes-per-second",
      KILOBYTES_PER_SECOND: "kilobytes-per-second",
      MEGABYTES_PER_SECOND: "megabytes-per-second",
      GIGABYTES_PER_SECOND: "gigabytes-per-second",
      // Airquality Index
      AQI: "aqi",
      // Water quality
      PH: "ph",
      // For air quality (pm2.5, pm10, formaldehyd)
      MILLIGRAM_PER_CUBIC_METER: "milligram-per-cubic-meter",
      MICROGRAM_PER_CUBIC_METER: "microgram-per-cubic-meter",
      NANOGRAM_PER_CUBIC_METER: "nanogram-per-cubic-meter",
      PARTICLES_PER_CUBIC_METER: "particles-per-cubic-meter",
      BECQUEREL_PER_CUBIC_METER: "becquerel-per-cubic-meter",
      // Noise units
      DECIBEL: "decibel"
    };
    var WEATHER_UNITS = {
      METRIC: "metric"
    };
    var DEVICE_FEATURE_UNITS_BY_CATEGORY = {
      [DEVICE_FEATURE_CATEGORIES.SWITCH]: [
        DEVICE_FEATURE_UNITS.AMPERE,
        DEVICE_FEATURE_UNITS.MILLI_VOLT,
        DEVICE_FEATURE_UNITS.VOLT,
        DEVICE_FEATURE_UNITS.WATT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.WATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR
      ],
      [DEVICE_FEATURE_CATEGORIES.BATTERY]: [DEVICE_FEATURE_UNITS.PERCENT],
      [DEVICE_FEATURE_CATEGORIES.CO_SENSOR]: [DEVICE_FEATURE_UNITS.PPM],
      [DEVICE_FEATURE_CATEGORIES.CO2_SENSOR]: [DEVICE_FEATURE_UNITS.PPM],
      [DEVICE_FEATURE_CATEGORIES.DISTANCE_SENSOR]: [
        DEVICE_FEATURE_UNITS.MM,
        DEVICE_FEATURE_UNITS.CM,
        DEVICE_FEATURE_UNITS.M,
        DEVICE_FEATURE_UNITS.KM,
        DEVICE_FEATURE_UNITS.INCH,
        DEVICE_FEATURE_UNITS.FEET,
        DEVICE_FEATURE_UNITS.MILE
      ],
      [DEVICE_FEATURE_CATEGORIES.LEVEL_SENSOR]: [
        DEVICE_FEATURE_UNITS.MM,
        DEVICE_FEATURE_UNITS.CM,
        DEVICE_FEATURE_UNITS.M,
        DEVICE_FEATURE_UNITS.KM,
        DEVICE_FEATURE_UNITS.INCH,
        DEVICE_FEATURE_UNITS.FEET,
        DEVICE_FEATURE_UNITS.MILE,
        DEVICE_FEATURE_UNITS.PERCENT
      ],
      [DEVICE_FEATURE_CATEGORIES.HUMIDITY_SENSOR]: [DEVICE_FEATURE_UNITS.PERCENT],
      [DEVICE_FEATURE_CATEGORIES.MAINTENANCE]: [DEVICE_FEATURE_UNITS.PERCENT],
      [DEVICE_FEATURE_CATEGORIES.SOIL_MOISTURE_SENSOR]: [DEVICE_FEATURE_UNITS.PERCENT],
      [DEVICE_FEATURE_CATEGORIES.LIGHT_SENSOR]: [DEVICE_FEATURE_UNITS.LUX],
      [DEVICE_FEATURE_CATEGORIES.PRESSURE_SENSOR]: [
        DEVICE_FEATURE_UNITS.PASCAL,
        DEVICE_FEATURE_UNITS.HECTO_PASCAL,
        DEVICE_FEATURE_UNITS.KILO_PASCAL,
        DEVICE_FEATURE_UNITS.BAR,
        DEVICE_FEATURE_UNITS.PSI,
        DEVICE_FEATURE_UNITS.MILLIBAR
      ],
      [DEVICE_FEATURE_CATEGORIES.TEMPERATURE_SENSOR]: [
        DEVICE_FEATURE_UNITS.CELSIUS,
        DEVICE_FEATURE_UNITS.FAHRENHEIT,
        DEVICE_FEATURE_UNITS.KELVIN
      ],
      [DEVICE_FEATURE_CATEGORIES.DEVICE_TEMPERATURE_SENSOR]: [
        DEVICE_FEATURE_UNITS.CELSIUS,
        DEVICE_FEATURE_UNITS.FAHRENHEIT
      ],
      [DEVICE_FEATURE_CATEGORIES.ENERGY_SENSOR]: [
        DEVICE_FEATURE_UNITS.MILLI_AMPERE,
        DEVICE_FEATURE_UNITS.AMPERE,
        DEVICE_FEATURE_UNITS.MILLI_VOLT,
        DEVICE_FEATURE_UNITS.VOLT,
        DEVICE_FEATURE_UNITS.WATT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.WATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR,
        DEVICE_FEATURE_UNITS.MEGAWATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOVOLT_AMPERE,
        DEVICE_FEATURE_UNITS.VOLT_AMPERE,
        DEVICE_FEATURE_UNITS.VOLT_AMPERE_REACTIVE,
        DEVICE_FEATURE_UNITS.EURO,
        DEVICE_FEATURE_UNITS.DOLLAR
      ],
      [DEVICE_FEATURE_CATEGORIES.ENERGY_PRODUCTION_SENSOR]: [
        DEVICE_FEATURE_UNITS.WATT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.WATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR,
        DEVICE_FEATURE_UNITS.EURO,
        DEVICE_FEATURE_UNITS.DOLLAR
      ],
      [DEVICE_FEATURE_CATEGORIES.GRID_SENSOR]: [
        DEVICE_FEATURE_UNITS.WATT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.WATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR
      ],
      [DEVICE_FEATURE_CATEGORIES.HOME_OUTPUT_SENSOR]: [
        DEVICE_FEATURE_UNITS.WATT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.WATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR
      ],
      [DEVICE_FEATURE_CATEGORIES.BATTERY_STORAGE]: [
        DEVICE_FEATURE_UNITS.PERCENT,
        DEVICE_FEATURE_UNITS.WATT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.WATT_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR
      ],
      [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_BATTERY]: [
        DEVICE_FEATURE_UNITS.CELSIUS,
        DEVICE_FEATURE_UNITS.FAHRENHEIT,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR,
        DEVICE_FEATURE_UNITS.KM,
        DEVICE_FEATURE_UNITS.MILE,
        DEVICE_FEATURE_UNITS.PERCENT,
        DEVICE_FEATURE_UNITS.VOLT
      ],
      [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_CHARGE]: [
        DEVICE_FEATURE_UNITS.AMPERE,
        DEVICE_FEATURE_UNITS.KILOWATT,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR,
        DEVICE_FEATURE_UNITS.MEGAWATT_HOUR,
        DEVICE_FEATURE_UNITS.PERCENT,
        DEVICE_FEATURE_UNITS.VOLT
      ],
      [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_CLIMATE]: [
        DEVICE_FEATURE_UNITS.CELSIUS,
        DEVICE_FEATURE_UNITS.FAHRENHEIT
      ],
      [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_DRIVE]: [
        DEVICE_FEATURE_UNITS.MILE_PER_HOUR,
        DEVICE_FEATURE_UNITS.KILOMETER_PER_HOUR,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR,
        DEVICE_FEATURE_UNITS.WATT_HOUR_PER_KM,
        DEVICE_FEATURE_UNITS.WATT_HOUR_PER_MILE,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_KM,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_MILE
      ],
      [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_CONSUMPTION]: [
        DEVICE_FEATURE_UNITS.WATT_HOUR_PER_KM,
        DEVICE_FEATURE_UNITS.WATT_HOUR_PER_MILE,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_KM,
        DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_MILE,
        DEVICE_FEATURE_UNITS.KM_PER_KILOWATT_HOUR,
        DEVICE_FEATURE_UNITS.MILE_PER_KILOWATT_HOUR
      ],
      [DEVICE_FEATURE_CATEGORIES.ELECTRICAL_VEHICLE_STATE]: [
        DEVICE_FEATURE_UNITS.KM,
        DEVICE_FEATURE_UNITS.MILE,
        DEVICE_FEATURE_UNITS.BAR,
        DEVICE_FEATURE_UNITS.PSI,
        DEVICE_FEATURE_UNITS.KILO_PASCAL
      ],
      [DEVICE_FEATURE_CATEGORIES.VOLUME_SENSOR]: [
        DEVICE_FEATURE_UNITS.LITER,
        DEVICE_FEATURE_UNITS.MILLILITER,
        DEVICE_FEATURE_UNITS.CUBIC_METER
      ],
      [DEVICE_FEATURE_CATEGORIES.WATER_HEATER]: [
        DEVICE_FEATURE_UNITS.CELSIUS,
        DEVICE_FEATURE_UNITS.FAHRENHEIT,
        DEVICE_FEATURE_UNITS.PERCENT,
        DEVICE_FEATURE_UNITS.LITER
      ],
      [DEVICE_FEATURE_CATEGORIES.WATER_VALVE]: [
        DEVICE_FEATURE_UNITS.CUBIC_METER_PER_HOUR,
        DEVICE_FEATURE_UNITS.SECONDS,
        DEVICE_FEATURE_UNITS.LITER
      ],
      [DEVICE_FEATURE_CATEGORIES.CURRENCY]: [
        DEVICE_FEATURE_UNITS.EURO,
        DEVICE_FEATURE_UNITS.DOLLAR,
        DEVICE_FEATURE_UNITS.BITCOIN,
        DEVICE_FEATURE_UNITS.LITECOIN,
        DEVICE_FEATURE_UNITS.ETHEREUM,
        DEVICE_FEATURE_UNITS.DOGECOIN,
        DEVICE_FEATURE_UNITS.POUND_STERLING
      ],
      [DEVICE_FEATURE_CATEGORIES.SPEED_SENSOR]: [
        DEVICE_FEATURE_UNITS.METER_PER_SECOND,
        DEVICE_FEATURE_UNITS.KILOMETER_PER_HOUR
      ],
      [DEVICE_FEATURE_CATEGORIES.PRECIPITATION_SENSOR]: [
        DEVICE_FEATURE_UNITS.MILLIMETER_PER_HOUR,
        DEVICE_FEATURE_UNITS.MILLIMETER_PER_DAY,
        DEVICE_FEATURE_UNITS.MILLI_VOLT
      ],
      [DEVICE_FEATURE_CATEGORIES.UV_SENSOR]: [DEVICE_FEATURE_UNITS.UV_INDEX],
      [DEVICE_FEATURE_CATEGORIES.DURATION]: [
        DEVICE_FEATURE_UNITS.MICROSECONDS,
        DEVICE_FEATURE_UNITS.MILLISECONDS,
        DEVICE_FEATURE_UNITS.SECONDS,
        DEVICE_FEATURE_UNITS.MINUTES,
        DEVICE_FEATURE_UNITS.HOURS,
        DEVICE_FEATURE_UNITS.DAYS,
        DEVICE_FEATURE_UNITS.WEEKS,
        DEVICE_FEATURE_UNITS.MONTHS,
        DEVICE_FEATURE_UNITS.YEARS
      ],
      [DEVICE_FEATURE_CATEGORIES.VOC_SENSOR]: [DEVICE_FEATURE_UNITS.PPB],
      [DEVICE_FEATURE_CATEGORIES.DATA]: [
        DEVICE_FEATURE_UNITS.BIT,
        DEVICE_FEATURE_UNITS.KILOBIT,
        DEVICE_FEATURE_UNITS.MEGABIT,
        DEVICE_FEATURE_UNITS.GIGABIT,
        DEVICE_FEATURE_UNITS.BYTE,
        DEVICE_FEATURE_UNITS.KILOBYTE,
        DEVICE_FEATURE_UNITS.MEGABYTE,
        DEVICE_FEATURE_UNITS.GIGABYTE,
        DEVICE_FEATURE_UNITS.TERABYTE
      ],
      [DEVICE_FEATURE_CATEGORIES.DATARATE]: [
        DEVICE_FEATURE_UNITS.BITS_PER_SECOND,
        DEVICE_FEATURE_UNITS.KILOBITS_PER_SECOND,
        DEVICE_FEATURE_UNITS.MEGABITS_PER_SECOND,
        DEVICE_FEATURE_UNITS.GIGABITS_PER_SECOND,
        DEVICE_FEATURE_UNITS.BYTES_PER_SECOND,
        DEVICE_FEATURE_UNITS.KILOBYTES_PER_SECOND,
        DEVICE_FEATURE_UNITS.MEGABYTES_PER_SECOND,
        DEVICE_FEATURE_UNITS.GIGABYTES_PER_SECOND
      ],
      [DEVICE_FEATURE_CATEGORIES.THERMOSTAT]: [DEVICE_FEATURE_UNITS.CELSIUS, DEVICE_FEATURE_UNITS.FAHRENHEIT],
      [DEVICE_FEATURE_CATEGORIES.AIR_CONDITIONING]: [DEVICE_FEATURE_UNITS.CELSIUS, DEVICE_FEATURE_UNITS.FAHRENHEIT],
      [DEVICE_FEATURE_CATEGORIES.FAN]: [DEVICE_FEATURE_UNITS.PERCENT],
      [DEVICE_FEATURE_CATEGORIES.AIRQUALITY_SENSOR]: [DEVICE_FEATURE_UNITS.AQI],
      [DEVICE_FEATURE_CATEGORIES.PH_SENSOR]: [DEVICE_FEATURE_UNITS.PH],
      [DEVICE_FEATURE_CATEGORIES.ORP_SENSOR]: [DEVICE_FEATURE_UNITS.MILLI_VOLT],
      [DEVICE_FEATURE_CATEGORIES.PM25_SENSOR]: [
        [DEVICE_FEATURE_UNITS.MILLIGRAM_PER_CUBIC_METER],
        [DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER],
        [DEVICE_FEATURE_UNITS.NANOGRAM_PER_CUBIC_METER]
      ],
      [DEVICE_FEATURE_CATEGORIES.PM10_SENSOR]: [
        [DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER],
        [DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER],
        [DEVICE_FEATURE_UNITS.NANOGRAM_PER_CUBIC_METER]
      ],
      [DEVICE_FEATURE_CATEGORIES.FORMALDEHYD_SENSOR]: [
        [DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER],
        [DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER],
        [DEVICE_FEATURE_UNITS.NANOGRAM_PER_CUBIC_METER]
      ],
      [DEVICE_FEATURE_CATEGORIES.NO2_SENSOR]: [
        DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER,
        DEVICE_FEATURE_UNITS.MILLIGRAM_PER_CUBIC_METER,
        DEVICE_FEATURE_UNITS.NANOGRAM_PER_CUBIC_METER
      ],
      [DEVICE_FEATURE_CATEGORIES.O3_SENSOR]: [
        DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER,
        DEVICE_FEATURE_UNITS.MILLIGRAM_PER_CUBIC_METER,
        DEVICE_FEATURE_UNITS.NANOGRAM_PER_CUBIC_METER
      ],
      [DEVICE_FEATURE_CATEGORIES.SO2_SENSOR]: [
        DEVICE_FEATURE_UNITS.MICROGRAM_PER_CUBIC_METER,
        DEVICE_FEATURE_UNITS.MILLIGRAM_PER_CUBIC_METER,
        DEVICE_FEATURE_UNITS.NANOGRAM_PER_CUBIC_METER
      ],
      [DEVICE_FEATURE_CATEGORIES.SURFACE]: [
        DEVICE_FEATURE_UNITS.SQUARE_CENTIMETER,
        DEVICE_FEATURE_UNITS.SQUARE_METER,
        DEVICE_FEATURE_UNITS.SQUARE_KILOMETER
      ]
    };
    var DEVICE_FEATURE_UNITS_BY_CATEGORY_AND_TYPE = {
      [DEVICE_FEATURE_CATEGORIES.AIRQUALITY_SENSOR]: {
        [DEVICE_FEATURE_TYPES.AIRQUALITY_SENSOR.AQI]: [DEVICE_FEATURE_UNITS.AQI],
        // The qualitative level is an enum, it carries no unit.
        [DEVICE_FEATURE_TYPES.AIRQUALITY_SENSOR.LEVEL]: []
      },
      [DEVICE_FEATURE_CATEGORIES.WATER_HEATER]: {
        [DEVICE_FEATURE_TYPES.WATER_HEATER.BINARY]: [],
        [DEVICE_FEATURE_TYPES.WATER_HEATER.MODE]: [],
        [DEVICE_FEATURE_TYPES.WATER_HEATER.TARGET_TEMPERATURE]: [
          DEVICE_FEATURE_UNITS.CELSIUS,
          DEVICE_FEATURE_UNITS.FAHRENHEIT
        ],
        [DEVICE_FEATURE_TYPES.WATER_HEATER.REMAINING_HOT_WATER]: [DEVICE_FEATURE_UNITS.PERCENT, DEVICE_FEATURE_UNITS.LITER],
        [DEVICE_FEATURE_TYPES.WATER_HEATER.HEATING]: [],
        [DEVICE_FEATURE_TYPES.WATER_HEATER.BOOST]: []
      },
      [DEVICE_FEATURE_CATEGORIES.WATER_VALVE]: {
        [DEVICE_FEATURE_TYPES.WATER_VALVE.CURRENT_DEVICE_STATUS]: [],
        [DEVICE_FEATURE_TYPES.WATER_VALVE.FLOW]: [DEVICE_FEATURE_UNITS.CUBIC_METER_PER_HOUR],
        [DEVICE_FEATURE_TYPES.WATER_VALVE.AUTO_CLOSE_WHEN_WATER_SHORTAGE]: [],
        [DEVICE_FEATURE_TYPES.WATER_VALVE.VALVE_WORK_STATE]: [],
        [DEVICE_FEATURE_TYPES.WATER_VALVE.REAL_TIME_IRRIGATION_DURATION]: [DEVICE_FEATURE_UNITS.SECONDS],
        [DEVICE_FEATURE_TYPES.WATER_VALVE.REAL_TIME_IRRIGATION_VOLUME]: [DEVICE_FEATURE_UNITS.LITER],
        [DEVICE_FEATURE_TYPES.WATER_VALVE.DAILY_IRRIGATION_VOLUME]: [DEVICE_FEATURE_UNITS.LITER]
      }
    };
    var MEASUREMENT_UNITS = {
      US: "us",
      METRIC: "metric"
    };
    var ACTIONS_STATUS = {
      PENDING: "pending",
      SUCCESS: "success",
      FAILED: "failed"
    };
    var DEVICE_POLL_FREQUENCIES = {
      EVERY_MINUTES: 60 * 1e3,
      EVERY_30_SECONDS: 30 * 1e3,
      EVERY_15_SECONDS: 15 * 1e3,
      EVERY_10_SECONDS: 10 * 1e3,
      EVERY_2_SECONDS: 2 * 1e3,
      EVERY_SECONDS: 1 * 1e3
    };
    var DEVICE_ROTATION = {
      DEGREES_0: "0",
      DEGREES_90: "90",
      DEGREES_180: "180",
      DEGREES_270: "270"
    };
    var WEBSOCKET_MESSAGE_TYPES = {
      ALARM: {
        ARMING: "alarm.arming",
        ARMED: "alarm.armed",
        DISARMED: "alarm.disarmed",
        PARTIALLY_ARMED: "alarm.partial-arm",
        PANIC: "alarm.panic"
      },
      BACKUP: {
        DOWNLOADED: "backup.downloaded"
      },
      DEVICE: {
        NEW_STATE: "device.new-state",
        NEW_STRING_STATE: "device.new-string-state"
      },
      JOB: {
        NEW: "job.new",
        UPDATED: "job.updated"
      },
      MESSAGE: {
        NEW: "message.new",
        SENT: "message.sent",
        AI_THINKING: "message.ai-thinking"
      },
      VOICE_ASSISTANT: {
        TRANSCRIPTION: "voice-assistant.transcription",
        RESPONSE: "voice-assistant.response",
        PROCESSING: "voice-assistant.processing",
        ERROR: "voice-assistant.error"
      },
      AUTHENTICATION: {
        REQUEST: "authenticate.request",
        INTEGRATION_REQUEST: "authenticate.integration-request",
        CONNECTED: "authentication.connected"
      },
      GATEWAY: {
        BACKUP_UPLOAD_PROGRESS: "gateway.backup-upload-progress",
        BACKUP_DOWNLOAD_PROGRESS: "gateway.backup-download-progress"
      },
      SCENE: {
        EXECUTING_ACTION: "scene.executing-action",
        FINISHED_EXECUTING_ACTION: "scene.finished-executing-action"
      },
      SYSTEM: {
        VACUUM_FINISHED: "system.vacuum-finished",
        WATCHTOWER_LOG: "system.watchtower-log",
        UPGRADE_ERROR: "system.upgrade-error"
      },
      LOCATION: {
        NEW: "location.new"
      },
      USER_PRESENCE: {
        LEFT_HOME: "user.left-home",
        BACK_HOME: "user.back-home",
        SEEN_AT_HOME: "user.seen-at-home"
      },
      LAN: {
        SCANNING: "lan.scanning"
      },
      MQTT: {
        CONNECTED: "mqtt.connected",
        ERROR: "mqtt.error",
        INSTALLATION_STATUS: "mqtt.install-status",
        DEBUG_NEW_MQTT_MESSAGE: "mqtt.debug.new-mqtt-message",
        HA_DISCOVERY_DEVICES_UPDATED: "mqtt.ha-discovery.devices-updated"
      },
      ZWAVEJS_UI: {
        CONNECTED: "zwavejs-ui.connected",
        ERROR: "zwavejs-ui.error",
        SCAN_COMPLETED: "zwavejs-ui.scan-completed"
      },
      ZIGBEE2MQTT: {
        DISCOVER: "zigbee2mqtt.discover",
        STATUS_CHANGE: "zigbee2mqtt.status-change",
        PERMIT_JOIN: "zigbee2mqtt.permit-join"
      },
      XIAOMI: {
        NEW_DEVICE: "xiaomi.new-device"
      },
      TASMOTA: {
        NEW_MQTT_DEVICE: "tasmota.new-mqtt-device",
        NEW_HTTP_DEVICE: "tasmota.new-http-device"
      },
      BLUETOOTH: {
        STATE: "bluetooth.status",
        DISCOVER: "bluetooth.discover"
      },
      EWELINK: {
        CONNECTED: "ewelink.connected",
        NEW_DEVICE: "ewelink.new-device",
        ERROR: "ewelink.error"
      },
      NUKI: {
        CONNECTED: "nuki.connected",
        NEW_MQTT_DEVICE: "nuki.new-mqtt-device",
        NEW_HTTP_DEVICE: "nuki.new-http-device",
        ERROR: "nuki.error"
      },
      BROADLINK: {
        LEARN_MODE: "broadlink.learn",
        SEND_MODE: "broadlink.send"
      },
      TUYA: {
        STATUS: "tuya.status",
        DISCOVER: "tuya.discover",
        ERROR: "tuya.error"
      },
      NETATMO: {
        STATUS: "netatmo.status",
        ERROR: {
          CONNECTED: "netatmo.error-connected",
          CONNECTING: "netatmo.error-connecting",
          PROCESSING_TOKEN: "netatmo.error-processing-token"
        }
      },
      MELCLOUD: {
        STATUS: "melcloud.status",
        DISCOVER: "melcloud.discover"
      },
      NODERED: {
        STATUS_CHANGE: "nodered.status-change",
        MQTT_ERROR: "nodered.mqtt-error"
      },
      MATTERBRIDGE: {
        STATUS_CHANGE: "matterbridge.status-change"
      },
      EXTERNAL_INTEGRATION: {
        STATUS_CHANGED: "external-integration.status-changed",
        DISCOVERED_DEVICES_UPDATED: "external-integration.discovered-devices-updated",
        CONNECTION_STATUS_UPDATED: "external-integration.connection-status-updated",
        DEVICE_SET_VALUE: "external-integration.device.set-value",
        DEVICE_POLL: "external-integration.device.poll",
        COMMAND_RESULT: "external-integration.command-result",
        SCAN_REQUEST: "external-integration.scan-request",
        DEVICE_CREATED: "external-integration.device-created",
        DEVICE_UPDATED: "external-integration.device-updated",
        DEVICE_DELETED: "external-integration.device-deleted",
        HEARTBEAT: "external-integration.heartbeat",
        CONFIG_UPDATED: "external-integration.config-updated",
        MESSAGE_SEND: "external-integration.message.send",
        HARDWARE_UPDATED: "external-integration.hardware-updated",
        OAUTH_GET_AUTHORIZE_URL: "external-integration.oauth.get-authorize-url",
        OAUTH_CALLBACK: "external-integration.oauth.callback",
        ACTION_RUN: "external-integration.action.run",
        CAMERA_GET_IMAGE: "external-integration.camera.get-image",
        WEATHER_GET: "external-integration.weather.get",
        WEATHER_GET_IMAGE: "external-integration.weather.get-image",
        WEATHER_REFRESH: "external-integration.weather.refresh",
        DEVICE_TRANSPORT_UPDATED: "external-integration.device-transport-updated",
        WEBHOOK_RECEIVED: "external-integration.webhook.received",
        WEBHOOK_REQUEST: "external-integration.webhook.request",
        WEBHOOK_UPDATED: "external-integration.webhook-updated"
      }
    };
    var DASHBOARD_TYPE = {
      MAIN: "main"
    };
    var DASHBOARD_VISIBILITY = {
      PRIVATE: "private",
      PUBLIC: "public"
    };
    var DASHBOARD_BOX_TYPE = {
      ALARM: "alarm",
      WEATHER: "weather",
      TEMPERATURE_IN_ROOM: "temperature-in-room",
      HUMIDITY_IN_ROOM: "humidity-in-room",
      USER_PRESENCE: "user-presence",
      CAMERA: "camera",
      DEVICES_IN_ROOM: "devices-in-room",
      DEVICES: "devices",
      CHART: "chart",
      ECOWATT: "ecowatt",
      EDF_TEMPO: "edf-tempo",
      CLOCK: "clock",
      SCENE: "scene",
      MUSIC: "music",
      GAUGE: "gauge",
      ENERGY_CONSUMPTION: "energy-consumption",
      VOICE_ASSISTANT: "voice-assistant",
      LINK: "link",
      PHOTO: "photo",
      SUN: "sun"
    };
    var ERROR_MESSAGES = {
      HOUSE_HAS_NO_COORDINATES: "HOUSE_HAS_NO_COORDINATES",
      SERVICE_NOT_CONFIGURED: "SERVICE_NOT_CONFIGURED",
      REQUEST_TO_THIRD_PARTY_FAILED: "REQUEST_TO_THIRD_PARTY_FAILED",
      INVALID_ACCESS_TOKEN: "INVALID_ACCESS_TOKEN",
      NO_CONNECTED_TO_THE_INTERNET: "NO_CONNECTED_TO_THE_INTERNET"
    };
    var DEVICE_FEATURE_STATE_AGGREGATE_TYPES = {
      MONTHLY: "monthly",
      DAILY: "daily",
      HOURLY: "hourly"
    };
    var DEFAULT_AGGREGATES_POLICY_IN_DAYS = {
      [DEVICE_FEATURE_STATE_AGGREGATE_TYPES.HOURLY]: 6 * 30,
      [DEVICE_FEATURE_STATE_AGGREGATE_TYPES.DAILY]: 365,
      [DEVICE_FEATURE_STATE_AGGREGATE_TYPES.MONTHLY]: 5 * 365
    };
    var SYSTEM_UPGRADE_ERROR_CODES = {
      // Gladys runs on an immutable image reference, no upgrade can ever be applied
      IMAGE_TAG_PINNED: "IMAGE_TAG_PINNED",
      // Watchtower ran fine but found no new image to install
      NO_UPDATE_APPLIED: "NO_UPDATE_APPLIED",
      // the Watchtower container exited with a non-zero status code
      WATCHTOWER_FAILED: "WATCHTOWER_FAILED",
      // the Watchtower container was still running after the timeout
      WATCHTOWER_TIMEOUT: "WATCHTOWER_TIMEOUT",
      // the container running Gladys could not be identified
      GLADYS_CONTAINER_NOT_FOUND: "GLADYS_CONTAINER_NOT_FOUND",
      UNKNOWN_ERROR: "UNKNOWN_ERROR"
    };
    var JOB_TYPES = {
      HOURLY_DEVICE_STATE_AGGREGATE: "hourly-device-state-aggregate",
      DAILY_DEVICE_STATE_AGGREGATE: "daily-device-state-aggregate",
      MONTHLY_DEVICE_STATE_AGGREGATE: "monthly-device-state-aggregate",
      GLADYS_GATEWAY_BACKUP: "gladys-gateway-backup",
      DEVICE_STATES_PURGE_SINGLE_FEATURE: "device-state-purge-single-feature",
      DEVICE_STATES_PURGE: "device-state-purge",
      DEVICE_STATES_PURGE_ALL_SQLITE_STATES: "device-state-purge-all-sqlite-states",
      DEVICE_STATES_PURGE_ORPHANED_DUCKDB_STATES: "device-state-purge-orphaned-duckdb-states",
      VACUUM: "vacuum",
      SERVICE_ZIGBEE2MQTT_BACKUP: "service-zigbee2mqtt-backup",
      SERVICE_NODE_RED_BACKUP: "service-node-red-backup",
      SERVICE_MATTER_BACKUP: "service-matter-backup",
      MIGRATE_SQLITE_TO_DUCKDB: "migrate-sqlite-to-duckdb",
      ENERGY_MONITORING_COST_CALCULATION_THIRTY_MINUTES: "energy-monitoring-cost-calculation-thirty-minutes",
      ENERGY_MONITORING_COST_CALCULATION_YESTERDAY: "energy-monitoring-cost-calculation-yesterday",
      ENERGY_MONITORING_COST_CALCULATION_BEGINNING: "energy-monitoring-cost-calculation-beginning",
      ENERGY_MONITORING_CONSUMPTION_FROM_INDEX_THIRTY_MINUTES: "energy-monitoring-consumption-from-index-thirty-minutes",
      ENERGY_MONITORING_CONSUMPTION_FROM_INDEX_BEGINNING: "energy-monitoring-consumption-from-index-beginning",
      ENERGY_MONITORING_PRODUCTION_FROM_INDEX_THIRTY_MINUTES: "energy-monitoring-production-from-index-thirty-minutes",
      ENERGY_MONITORING_PRODUCTION_FROM_INDEX_BEGINNING: "energy-monitoring-production-from-index-beginning",
      SERVICE_ENEDIS_SYNC: "service-enedis-sync",
      AI_WEEKLY_DIGEST: "ai-weekly-digest",
      DEVICE_MIGRATE: "device-migrate"
    };
    var JOB_STATUS = {
      IN_PROGRESS: "in-progress",
      SUCCESS: "success",
      FAILED: "failed"
    };
    var JOB_ERROR_TYPES = {
      PURGED_WHEN_RESTARTED: "purged-when-restarted",
      UNKNOWN_ERROR: "unknown-error"
    };
    var DEFAULT_VALUE_HUMIDITY = {
      MINIMUM: 45,
      MAXIMUM: 60
    };
    var DEFAULT_VALUE_TEMPERATURE = {
      MINIMUM: 17,
      MAXIMUM: 24
    };
    var ALARM_MODES = {
      DISARMED: "disarmed",
      ARMED: "armed",
      PARTIALLY_ARMED: "partially-armed",
      PANIC: "panic"
    };
    var ENERGY_CONTRACT_TYPES = {
      // Generic base contract
      BASE: "base",
      // Generic peak off peak contract
      PEAK_OFF_PEAK: "peak-off-peak",
      // EDF Tempo
      EDF_TEMPO: "edf-tempo"
    };
    var ENERGY_PRICE_TYPES = {
      CONSUMPTION: "consumption",
      SUBSCRIPTION: "subscription"
    };
    var ENERGY_PRICE_DAY_TYPES = {
      RED: "red",
      BLUE: "blue",
      WHITE: "white"
    };
    var AI_CHAT_TOOL_CATEGORIES = {
      SCENES: "scenes",
      DEVICE_CONTROL: "device_control",
      DEVICE_QUERY: "device_query",
      WEATHER: "weather",
      WEB_AND_TIME: "web_and_time",
      OTHER: "other"
    };
    var AI_CHAT_PURPOSES = {
      CHAT: "chat",
      INTENT_CLASSIFICATION: "intent-classification",
      WEEKLY_DIGEST: "weekly-digest"
    };
    var createList = (obj) => {
      const list = [];
      Object.keys(obj).forEach((key) => {
        if (typeof obj[key] === "object") {
          Object.keys(obj[key]).forEach((secondKey) => {
            list.push(obj[key][secondKey]);
          });
        } else {
          list.push(obj[key]);
        }
      });
      return list;
    };
    var EVENT_LIST = createList(EVENTS);
    var LIFE_EVENT_LIST = createList(LIFE_EVENTS);
    var ACTION_LIST = createList(ACTIONS);
    var CONDITION_LIST = createList(CONDITIONS);
    var DEVICE_FEATURE_CATEGORIES_LIST = createList(DEVICE_FEATURE_CATEGORIES);
    var DEVICE_FEATURE_TYPES_LIST = createList(DEVICE_FEATURE_TYPES);
    var USER_ROLE_LIST = createList(USER_ROLE);
    var AVAILABLE_LANGUAGES_LIST = createList(AVAILABLE_LANGUAGES);
    var SESSION_TOKEN_TYPE_LIST = createList(SESSION_TOKEN_TYPES);
    var DEVICE_FEATURE_UNITS_LIST = createList(DEVICE_FEATURE_UNITS);
    var DASHBOARD_TYPE_LIST = createList(DASHBOARD_TYPE);
    var DASHBOARD_VISIBILITY_LIST = createList(DASHBOARD_VISIBILITY);
    var DASHBOARD_BOX_TYPE_LIST = createList(DASHBOARD_BOX_TYPE);
    var DEVICE_FEATURE_STATE_AGGREGATE_TYPES_LIST = createList(DEVICE_FEATURE_STATE_AGGREGATE_TYPES);
    var JOB_TYPES_LIST = createList(JOB_TYPES);
    var JOB_STATUS_LIST = createList(JOB_STATUS);
    var JOB_ERROR_TYPES_LIST = createList(JOB_ERROR_TYPES);
    var ALARM_MODES_LIST = createList(ALARM_MODES);
    var AI_CHAT_TOOL_CATEGORIES_LIST = createList(AI_CHAT_TOOL_CATEGORIES);
    var ENERGY_CONTRACT_TYPES_LIST = createList(ENERGY_CONTRACT_TYPES);
    var ENERGY_PRICE_TYPES_LIST = createList(ENERGY_PRICE_TYPES);
    var ENERGY_PRICE_DAY_TYPES_LIST = createList(ENERGY_PRICE_DAY_TYPES);
    module.exports.STATE = STATE;
    module.exports.BUTTON_STATUS = BUTTON_STATUS;
    module.exports.BUTTON_PUSH = BUTTON_PUSH;
    module.exports.COVER_STATE = COVER_STATE;
    module.exports.LOCK = LOCK;
    module.exports.SIREN_LMH_VOLUME = SIREN_LMH_VOLUME;
    module.exports.AC_MODE = AC_MODE;
    module.exports.CAMERA_MOVE = CAMERA_MOVE;
    module.exports.THERMOSTAT_MODE = THERMOSTAT_MODE;
    module.exports.THERMOSTAT_OPERATING_STATE = THERMOSTAT_OPERATING_STATE;
    module.exports.FAN_MODE = FAN_MODE;
    module.exports.FAN_AIRFLOW_DIRECTION = FAN_AIRFLOW_DIRECTION;
    module.exports.FAN_ROCK_SETTING = FAN_ROCK_SETTING;
    module.exports.FAN_WIND_SETTING = FAN_WIND_SETTING;
    module.exports.getFanFeatureOptions = getFanFeatureOptions;
    module.exports.AC_FAN_SPEED = AC_FAN_SPEED;
    module.exports.AC_SWING_HORIZONTAL = AC_SWING_HORIZONTAL;
    module.exports.AC_SWING_VERTICAL = AC_SWING_VERTICAL;
    module.exports.PILOT_WIRE_MODE = PILOT_WIRE_MODE;
    module.exports.VACUUM_CLEANER_STATE = VACUUM_CLEANER_STATE;
    module.exports.VACUUM_CLEANER_MODE = VACUUM_CLEANER_MODE;
    module.exports.VACUUM_CLEANER_CLEAN_MODE = VACUUM_CLEANER_CLEAN_MODE;
    module.exports.CHARGING_STATION_CONNECTOR_STATUS = CHARGING_STATION_CONNECTOR_STATUS;
    module.exports.CHARGING_STATION_CHARGING_STATE = CHARGING_STATION_CHARGING_STATE;
    module.exports.LIQUID_STATE = LIQUID_STATE;
    module.exports.WATER_HEATER_MODE = WATER_HEATER_MODE;
    module.exports.WATER_VALVE_CURRENT_DEVICE_STATUS = WATER_VALVE_CURRENT_DEVICE_STATUS;
    module.exports.EVENTS = EVENTS;
    module.exports.LIFE_EVENTS = LIFE_EVENTS;
    module.exports.STATES = STATES;
    module.exports.CONDITIONS = CONDITIONS;
    module.exports.ACTIONS = ACTIONS;
    module.exports.CONDITION_ACTIONS = CONDITION_ACTIONS;
    module.exports.INTENTS = INTENTS;
    module.exports.DEVICE_FEATURE_CATEGORIES = DEVICE_FEATURE_CATEGORIES;
    module.exports.DEVICE_FEATURE_TYPES = DEVICE_FEATURE_TYPES;
    module.exports.MEASUREMENT_UNITS = MEASUREMENT_UNITS;
    module.exports.ACTIONS_STATUS = ACTIONS_STATUS;
    module.exports.USER_ROLE = USER_ROLE;
    module.exports.AVAILABLE_LANGUAGES = AVAILABLE_LANGUAGES;
    module.exports.SESSION_TOKEN_TYPES = SESSION_TOKEN_TYPES;
    module.exports.EVENT_LIST = EVENT_LIST;
    module.exports.LIFE_EVENT_LIST = LIFE_EVENT_LIST;
    module.exports.ACTION_LIST = ACTION_LIST;
    module.exports.CONDITION_LIST = CONDITION_LIST;
    module.exports.DEVICE_FEATURE_CATEGORIES_LIST = DEVICE_FEATURE_CATEGORIES_LIST;
    module.exports.DEVICE_FEATURE_TYPES_LIST = DEVICE_FEATURE_TYPES_LIST;
    module.exports.USER_ROLE_LIST = USER_ROLE_LIST;
    module.exports.AVAILABLE_LANGUAGES_LIST = AVAILABLE_LANGUAGES_LIST;
    module.exports.SESSION_TOKEN_TYPE_LIST = SESSION_TOKEN_TYPE_LIST;
    module.exports.DEVICE_POLL_FREQUENCIES = DEVICE_POLL_FREQUENCIES;
    module.exports.DEVICE_POLL_FREQUENCIES_LIST = createList(DEVICE_POLL_FREQUENCIES);
    module.exports.DEVICE_ROTATION = DEVICE_ROTATION;
    module.exports.WEBSOCKET_MESSAGE_TYPES = WEBSOCKET_MESSAGE_TYPES;
    module.exports.DEVICE_FEATURE_UNITS = DEVICE_FEATURE_UNITS;
    module.exports.DEVICE_FEATURE_UNITS_LIST = DEVICE_FEATURE_UNITS_LIST;
    module.exports.DEVICE_FEATURE_UNITS_BY_CATEGORY = DEVICE_FEATURE_UNITS_BY_CATEGORY;
    module.exports.DEVICE_FEATURE_UNITS_BY_CATEGORY_AND_TYPE = DEVICE_FEATURE_UNITS_BY_CATEGORY_AND_TYPE;
    module.exports.SERVICE_STATUS = SERVICE_STATUS;
    module.exports.SERVICE_STATUS_LIST = createList(SERVICE_STATUS);
    module.exports.SERVICE_TYPES = SERVICE_TYPES;
    module.exports.SERVICE_TYPES_LIST = createList(SERVICE_TYPES);
    module.exports.INTEGRATION_CATALOG_CATEGORIES = INTEGRATION_CATALOG_CATEGORIES;
    module.exports.SYSTEM_VARIABLE_NAMES = SYSTEM_VARIABLE_NAMES;
    module.exports.DASHBOARD_TYPE = DASHBOARD_TYPE;
    module.exports.DASHBOARD_VISIBILITY = DASHBOARD_VISIBILITY;
    module.exports.DASHBOARD_VISIBILITY_LIST = DASHBOARD_VISIBILITY_LIST;
    module.exports.DASHBOARD_TYPE_LIST = DASHBOARD_TYPE_LIST;
    module.exports.DASHBOARD_BOX_TYPE = DASHBOARD_BOX_TYPE;
    module.exports.DASHBOARD_BOX_TYPE_LIST = DASHBOARD_BOX_TYPE_LIST;
    module.exports.ERROR_MESSAGES = ERROR_MESSAGES;
    module.exports.WEATHER_UNITS = WEATHER_UNITS;
    module.exports.DEVICE_FEATURE_STATE_AGGREGATE_TYPES = DEVICE_FEATURE_STATE_AGGREGATE_TYPES;
    module.exports.DEVICE_FEATURE_STATE_AGGREGATE_TYPES_LIST = DEVICE_FEATURE_STATE_AGGREGATE_TYPES_LIST;
    module.exports.DEFAULT_AGGREGATES_POLICY_IN_DAYS = DEFAULT_AGGREGATES_POLICY_IN_DAYS;
    module.exports.SYSTEM_UPGRADE_ERROR_CODES = SYSTEM_UPGRADE_ERROR_CODES;
    module.exports.JOB_TYPES = JOB_TYPES;
    module.exports.JOB_TYPES_LIST = JOB_TYPES_LIST;
    module.exports.JOB_STATUS = JOB_STATUS;
    module.exports.JOB_STATUS_LIST = JOB_STATUS_LIST;
    module.exports.JOB_ERROR_TYPES = JOB_ERROR_TYPES;
    module.exports.JOB_ERROR_TYPES_LIST = JOB_ERROR_TYPES_LIST;
    module.exports.DEFAULT_VALUE_HUMIDITY = DEFAULT_VALUE_HUMIDITY;
    module.exports.DEFAULT_VALUE_TEMPERATURE = DEFAULT_VALUE_TEMPERATURE;
    module.exports.ALARM_MODES = ALARM_MODES;
    module.exports.ALARM_MODES_LIST = ALARM_MODES_LIST;
    module.exports.AI_CHAT_TOOL_CATEGORIES = AI_CHAT_TOOL_CATEGORIES;
    module.exports.AI_CHAT_TOOL_CATEGORIES_LIST = AI_CHAT_TOOL_CATEGORIES_LIST;
    module.exports.AI_CHAT_PURPOSES = AI_CHAT_PURPOSES;
    module.exports.MUSIC_PLAYBACK_STATE = MUSIC_PLAYBACK_STATE;
    module.exports.OPENING_SENSOR_STATE = OPENING_SENSOR_STATE;
    module.exports.ENERGY_CONTRACT_TYPES = ENERGY_CONTRACT_TYPES;
    module.exports.ENERGY_CONTRACT_TYPES_LIST = ENERGY_CONTRACT_TYPES_LIST;
    module.exports.ENERGY_PRICE_TYPES = ENERGY_PRICE_TYPES;
    module.exports.ENERGY_PRICE_TYPES_LIST = ENERGY_PRICE_TYPES_LIST;
    module.exports.ENERGY_PRICE_DAY_TYPES = ENERGY_PRICE_DAY_TYPES;
    module.exports.ENERGY_PRICE_DAY_TYPES_LIST = ENERGY_PRICE_DAY_TYPES_LIST;
    module.exports.LEVEL_MATTER_STATE = LEVEL_MATTER_STATE;
    module.exports.AIR_QUALITY_LEVEL = AIR_QUALITY_LEVEL;
  }
});

// server/utils/unit-conversions.js
var require_unit_conversions = __commonJS({
  "server/utils/unit-conversions.js"(exports, module) {
    var { DEVICE_FEATURE_UNITS, MEASUREMENT_UNITS } = require_constants();
    var DISTANCE_UNIT_CONVERSIONS = {
      [MEASUREMENT_UNITS.US]: {
        [DEVICE_FEATURE_UNITS.MM]: { unit: DEVICE_FEATURE_UNITS.INCH, convert: (mm) => mm / 25.4 },
        [DEVICE_FEATURE_UNITS.CM]: { unit: DEVICE_FEATURE_UNITS.INCH, convert: (cm) => cm / 2.54 },
        [DEVICE_FEATURE_UNITS.M]: { unit: DEVICE_FEATURE_UNITS.FEET, convert: (m) => m * 3.28084 },
        [DEVICE_FEATURE_UNITS.KM]: { unit: DEVICE_FEATURE_UNITS.MILE, convert: (km) => km / 1.60934 },
        [DEVICE_FEATURE_UNITS.KILOMETER_PER_HOUR]: {
          unit: DEVICE_FEATURE_UNITS.MILE_PER_HOUR,
          convert: (kmh) => kmh / 1.60934
        },
        [DEVICE_FEATURE_UNITS.METER_PER_SECOND]: {
          unit: DEVICE_FEATURE_UNITS.FEET_PER_SECOND,
          convert: (ms) => ms * 3.28084
        },
        [DEVICE_FEATURE_UNITS.KM_PER_KILOWATT_HOUR]: {
          unit: DEVICE_FEATURE_UNITS.MILE_PER_KILOWATT_HOUR,
          convert: (kmpkwh) => kmpkwh / 1.60934
        },
        [DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_KM]: {
          unit: DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_MILE,
          convert: (kwh) => kwh / 1.60934
        },
        [DEVICE_FEATURE_UNITS.WATT_HOUR_PER_KM]: {
          unit: DEVICE_FEATURE_UNITS.WATT_HOUR_PER_MILE,
          convert: (wh) => wh / 1.60934
        }
      },
      [MEASUREMENT_UNITS.METRIC]: {
        [DEVICE_FEATURE_UNITS.INCH]: {
          unit: DEVICE_FEATURE_UNITS.MM,
          convert: (inch) => inch * 25.4
        },
        [DEVICE_FEATURE_UNITS.FEET]: {
          unit: DEVICE_FEATURE_UNITS.M,
          convert: (feet) => feet * 0.3048
        },
        [DEVICE_FEATURE_UNITS.MILE]: { unit: DEVICE_FEATURE_UNITS.KM, convert: (mile) => mile * 1.60934 },
        [DEVICE_FEATURE_UNITS.MILE_PER_HOUR]: {
          unit: DEVICE_FEATURE_UNITS.KILOMETER_PER_HOUR,
          convert: (mph) => mph * 1.60934
        },
        [DEVICE_FEATURE_UNITS.FEET_PER_SECOND]: {
          unit: DEVICE_FEATURE_UNITS.METER_PER_SECOND,
          convert: (fps) => fps * 0.3048
        },
        [DEVICE_FEATURE_UNITS.MILE_PER_KILOWATT_HOUR]: {
          unit: DEVICE_FEATURE_UNITS.KM_PER_KILOWATT_HOUR,
          convert: (kwh) => kwh * 1.60934
        },
        [DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_MILE]: {
          unit: DEVICE_FEATURE_UNITS.KILOWATT_HOUR_PER_100_KM,
          convert: (kwh) => kwh * 1.60934
        },
        [DEVICE_FEATURE_UNITS.WATT_HOUR_PER_MILE]: {
          unit: DEVICE_FEATURE_UNITS.WATT_HOUR_PER_KM,
          convert: (wh) => wh * 1.60934
        }
      }
    };
    var PRESSURE_UNIT_CONVERSIONS = {
      [MEASUREMENT_UNITS.US]: {
        [DEVICE_FEATURE_UNITS.BAR]: { unit: DEVICE_FEATURE_UNITS.PSI, convert: (bar) => bar * 14.5037738007218 },
        [DEVICE_FEATURE_UNITS.MILLIBAR]: { unit: DEVICE_FEATURE_UNITS.PSI, convert: (mbar) => mbar * 0.0145037738007218 },
        [DEVICE_FEATURE_UNITS.KILO_PASCAL]: { unit: DEVICE_FEATURE_UNITS.PSI, convert: (kpa) => kpa * 0.145037738007218 }
      },
      [MEASUREMENT_UNITS.METRIC]: {
        [DEVICE_FEATURE_UNITS.PSI]: { unit: DEVICE_FEATURE_UNITS.BAR, convert: (psi) => psi / 14.5037738007218 },
        [DEVICE_FEATURE_UNITS.KILO_PASCAL]: { unit: DEVICE_FEATURE_UNITS.BAR, convert: (kpa) => kpa / 100 }
      }
    };
    var ENERGY_UNIT_FACTORS_IN_WH = {
      [DEVICE_FEATURE_UNITS.WATT_HOUR]: 1,
      [DEVICE_FEATURE_UNITS.KILOWATT_HOUR]: 1e3,
      [DEVICE_FEATURE_UNITS.MEGAWATT_HOUR]: 1e6
    };
    var UNIT_CONVERSIONS = {
      [MEASUREMENT_UNITS.US]: {
        ...DISTANCE_UNIT_CONVERSIONS[MEASUREMENT_UNITS.US],
        ...PRESSURE_UNIT_CONVERSIONS[MEASUREMENT_UNITS.US]
      },
      [MEASUREMENT_UNITS.METRIC]: {
        ...DISTANCE_UNIT_CONVERSIONS[MEASUREMENT_UNITS.METRIC],
        ...PRESSURE_UNIT_CONVERSIONS[MEASUREMENT_UNITS.METRIC]
      }
    };
    module.exports = {
      ENERGY_UNIT_FACTORS_IN_WH,
      UNIT_CONVERSIONS
    };
  }
});

// server/utils/units.js
var require_units = __commonJS({
  "server/utils/units.js"(exports, module) {
    var { ENERGY_UNIT_FACTORS_IN_WH, UNIT_CONVERSIONS } = require_unit_conversions();
    function celsiusToFahrenheit(celsius) {
      return celsius * 9 / 5 + 32;
    }
    function fahrenheitToCelsius(fahrenheit) {
      return (fahrenheit - 32) * 5 / 9;
    }
    var hueToRgb = (p, q, t2) => {
      let t = t2;
      if (t < 0) {
        t += 1;
      }
      if (t > 1) {
        t -= 1;
      }
      if (t < 1 / 6) {
        return p + (q - p) * 6 * t;
      }
      if (t < 1 / 2) {
        return q;
      }
      if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
      }
      return p;
    };
    function hslToRgb(h, s, l) {
      if (s === 0) {
        return [l, l, l];
      }
      const h2 = h / 360;
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      return [
        Math.round(hueToRgb(p, q, h2 + 1 / 3) * 255),
        Math.round(hueToRgb(p, q, h2) * 255),
        Math.round(hueToRgb(p, q, h2 - 1 / 3) * 255)
      ];
    }
    function smartRound(value) {
      if (Math.abs(value) < 1) {
        return value;
      }
      if (Math.abs(value) < 10) {
        return Math.round(value * 100) / 100;
      }
      if (Math.abs(value) < 1e3) {
        return Math.round(value * 10) / 10;
      }
      return Math.round(value);
    }
    function checkAndConvertUnit(value, fromUnit, userPreference) {
      const unitsConvertUserPreference = UNIT_CONVERSIONS[userPreference];
      if (!unitsConvertUserPreference) {
        return { value, unit: fromUnit };
      }
      const unitConversionParams = unitsConvertUserPreference[fromUnit];
      if (!unitConversionParams) {
        return { value, unit: fromUnit };
      }
      if (value !== null) {
        const convertedValue = smartRound(unitConversionParams.convert(value));
        return { value: convertedValue, unit: unitConversionParams.unit };
      }
      return { value, unit: unitConversionParams.unit };
    }
    function convertEnergyUnit(value, fromUnit, toUnit) {
      if (value === null || value === void 0) {
        return value;
      }
      if (!fromUnit || !toUnit || fromUnit === toUnit) {
        return value;
      }
      const fromFactor = ENERGY_UNIT_FACTORS_IN_WH[fromUnit];
      const toFactor = ENERGY_UNIT_FACTORS_IN_WH[toUnit];
      if (!fromFactor || !toFactor) {
        return value;
      }
      return value * fromFactor / toFactor;
    }
    module.exports = {
      celsiusToFahrenheit,
      fahrenheitToCelsius,
      hslToRgb,
      checkAndConvertUnit,
      convertEnergyUnit,
      smartRound
    };
  }
});
const __cjsModule = require_units();
export default __cjsModule;
export const celsiusToFahrenheit = __cjsModule.celsiusToFahrenheit;
export const fahrenheitToCelsius = __cjsModule.fahrenheitToCelsius;
export const hslToRgb = __cjsModule.hslToRgb;
export const checkAndConvertUnit = __cjsModule.checkAndConvertUnit;
export const convertEnergyUnit = __cjsModule.convertEnergyUnit;
export const smartRound = __cjsModule.smartRound;
